import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import { Fab, Grid, FormControl, InputLabel, Select, MenuItem, Input, Hidden } from '@material-ui/core';
import EtapeProiectAdd from '../../commons/dialogs/EtapeProiectAdd'
import Ws from '../../providers/Ws';
import FromServer from './FromServer';
import Utils from '../../providers/Utils';
import EtapeListBeta from '../../commons/EtapeListBeta'
import InsertUpdateTask from '../../commons/dialogs/InsertUpdateTask'
import LocalStorage from '../../providers/LocalStorage';
import InsertUpdateEtapa from '../../commons/dialogs/InsertUpdateEtapa'
import AlertDialog from '../../commons/dialogs/AlertDialog'
import GanttEtapeWeekView from '../../commons/GanttEtapeWeekView'
import GanttProiecteMonthView from '../../commons/GanttProiecteMonthView'
import GanttProiectIntegral from '../../commons/GanttProiectIntegral'
import GanttEtapeMonthView from '../../commons/GanttEtapeMonthView'
import GanttTaskuriFullView from '../../commons/GanttTaskuriFullView'
import avatar from '../../Pics/avatar.jpg'
import TimpiLucru from '../../commons/dialogs/TimpiLucru';
import ButtonsModules from '../../commons/ButtonsModules';
import TaskuriDocumente from '../../commons/dialogs/TaskuriDocumente';
import EtapeDocumente from '../../commons/dialogs/EtapeDocumente';
import AlertNew from '../../commons/dialogs/AlertNew';
import OtherViewProiectIntegral from './OtherViewProiectIntegral';
import AlertIntarziereTask from '../../commons/dialogs/AlertIntarziereTask';
import DrepturiAcces from '../drepturiacces/DrepturiAcces';
import TasksAngajatView from './TasksAngajatView';

import { ReactComponent as IdeeaView } from '../../Pics/iconsManagement/ideea_view.svg';
import { ReactComponent as TableView } from '../../Pics/iconsManagement/table_view.svg';
import { ReactComponent as GanttView } from '../../Pics/iconsManagement/gantt_view.svg';

import { ReactComponent as IdeeaViewBlue } from '../../Pics/iconsManagement/ideea_view_blue.svg';
import { ReactComponent as TableViewBlue } from '../../Pics/iconsManagement/table_view_blue.svg';
import { ReactComponent as GanttViewBlue } from '../../Pics/iconsManagement/gantt_view_blue.svg';


export default class EtapeProiect extends SpecificComponent {
    constructor(props) {

        super(props);

        this.insertTaskRef = React.createRef()
        this.ganttChange = React.createRef()
        this.state = {

            etape: [],
            etapeStatus: [{
                id: 'Finalizata',
                text: this.dictionary.proiecte.status.finalizata
            },
            {
                id: 'InLucru',
                text: this.dictionary.proiecte.status.inlucru
            },
            {
                id: 'Blocat',
                text: this.dictionary.proiecte.status.blocat
            }
            ],
            culoriTaskuri: new Utils().culoriTaskuri(),
            status: '',
            responsabil: 1,
            nimicInEtape: 'Nu sunt elemente in lista',
            useri: [],
            openInsert: false,
            menuOpen: false,
            elSelectat: {},
            isOpenMenuAvatar: false,
            listTaskuri: [],
            isOpenInsertTask: false,
            objInfoTask: { poza: '', statusul: '', cand_data: null, cand_ora: null, titlu: 'Click aici si numeste sarcina noua', nume: '', cand_ora: '00:00', pana_cand_ora: '00:00', descriere: this.dictionary.proiecte.etapeProiect.descriereTask, color: 'rgb(108, 96, 197)' },
            strDataStart: this.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: this.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: new Date(),
            dtDataFinish: new Date(),
            isHiddenCalendarFinish: true,
            isHiddenCalendar: true,
            isOpenMenuEtape: false,
            objEtapaInfo: { denumire: '', note: '', durata_de_la: new Date(), durata_pana_la: new Date(new Utils().defaultDataPlus7Days()), cand_ora: '00:00', pana_cand_ora: '00:00' },
            isEtapaOpen: false,
            isOpenAlertDelete: false,
            strEtapaAlert: '',
            isOpenEtapaInsert: '',
            objInfoProiect: [{ perioada_dela: '', perioada_panala: '' }],
            listSubTaskuri: [],
            isOpenEtapaInsert: false,
            isOpenAlertPerioadaTask: false,
            objPerioadaGantt: {},
            listProiecte: [],
            isOpenUtilizator: false,
            listEtapeAll: [],
            windowWidth: 1000,
            monthView: true,
            etapaView: true,
            etapaViewTop: false,
            etapaSelectataView: false,
            taskSelectatView: false,
            objTaskSelectat: { id: 0 },
            objEtapaSelectata: { id: 0 },
            listTaskuriAll: [],
            objUser: { id: 0, drepturi_access: {} },
            isOpenTimpiLucru: false,
            objTimpLucru: {
                data_introdusa: new Utils().defaultData(),
                nr_ore: '00',
                nr_minute: '00',
                zile_cumulate: 0
            },
            isOpenListDocumente: false,
            listTimpiLucru: [],
            listDocumenteTask: [],
            isOpenAlertTaskDocument: false,
            objTaskFile: {},
            isOpenListDocumenteE: false,
            listDocumenteEtapa: [],
            objEtapaFile: {},
            isOpenAlertEtapaDocument: false,
            openDeleteTask: false,
            tableView: false,
            thinkView: false,
            ganttView: true,
            viewOption: 'Vezi in mod Tabel',
            indexEtapa: 0,
            openAlertIntarziat: false,
            motivIntarziat: '',
            openAlertIntarziatS: false,
            angajatView: [],
            isOpenAlertPerioadaTaskDt: false,
            mesajAlertDT: '',
            alertView: false

        }
    }

    drepturiAccess = new DrepturiAcces()

    utils = new Utils()
    ls = new LocalStorage()
    ws = new Ws()

    componentDidMount() {

        window.addEventListener('resize', this.getWindowWidth)


        this.getDetaliiUser()

    }

    getDetaliiUser = async () => {
        let ws = new Ws()

        let ls = new LocalStorage()

        let user = await ws.customSelect(`select u.id, a.nume, a.poza , u.email, u.telefon from angajati a 
                                        left outer join useri u on (a.id_user = u.id) where u.id = @p1 `, {
            p1: ls.GetUserData().InfoUser.IdUser
        })

        // console.log('user :', user);


        let dA = await this.drepturiAccess.getDrepturiAplicatie()

        let u = { ...user.Content[0] }

        u.drepturi_access = dA

        console.warn('dA :>> ', dA);

        console.log('u :>> ', u);
        if (user.Succes) {
            this.setState({
                objUser: u,
                windowWidth: window.innerWidth
            }, () => {
                this.getData()
                //  console.log('this.staet.objUser :', this.state.objUser);
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getWindowWidth)
    }

    getEtapaId = () => {
        let ls = new LocalStorage();

        let etapa = ls.GetEtapaId();

        localStorage.removeItem('etapaId')

        // console.log('etapaSelectata :', etapa);

        if (etapa !== null) {

            this.ganttChange.current.etapaClick(etapa)
        }

    }


    getWindowWidth = () => {

        // console.log('window :', window.innerWidth);
        this.setState({ windowWidth: window.innerWidth })
    }



    taskData = {}

    getData = async () => {

        // console.warn('enterGet Data :')

        let fS = new FromServer();

        let ut = new Utils();

        let ws = new Ws()

        let ls = new LocalStorage();

        let _proiecte = ws.customSelect('select * from proiecte where 1 = @p1', {
            p1: 1
        })

        let [u, e, t, i, sT, p, eA, tA] = await Promise.all([fS.getUsers(this.props.idproiect), fS.getEtape(this.props.idproiect), fS.getTaskuri(this.props.idproiect), fS.getInfoProiect(this.props.idproiect), fS.getSubTaskuri(this.props.idproiect), _proiecte, fS.getEtapeAll(), fS.getTaskuriAll()])


        let etapeTEst = await ws.customSelect('select * from proiecte_etape where id_proiect = @p1', {
            p1: this.props.idproiect
        })

        console.log('etapeTEst :>> ', etapeTEst);
        // console.log('e :',e);
        console.log('u :', u);
        // console.log('t :', t);
        console.warn('i :', i);
        // console.log('sT :', sT);
        // console.log('p :', p);
        // console.log('eA :', eA);
        // console.log('tA :', tA);


        let iProiect = { ...i[0] }
        let tasks = [...t]

        let cloneEtape = [...e]

        let subT = sT

        let counter = t.length;

        let counter5 = subT.length



        let newU = []

        for (let i = 0, n = u.length; i < n; i++) {

            let idx = newU.findIndex(n => n.id_linie === u[i].id_linie)
            u[i].show_tag = false

            if (idx === -1) {
                newU.push(u[i])
            }
        }

        // console.log('newU :>> ', newU);


        //     for(let i =0 ; i< counter ; i++ ){

        //             if(tasks[i].statusul !== 'Finalizat'){

        //              if ( new Date(ut.ParseDataFromSql(tasks[i].pana_cand_data)) <= new Date() ){
        //                 // console.log('colorTask :');
        //                 tasks[i].color = '#ff3f3f'
        //             }else if(new Date(ut.ParseDataFromSql(tasks[i].cand_data)) > new Date()){
        //                 tasks[i].color = 'rgb(251, 141, 0)'
        //             }else{
        //                 tasks[i].color = 'rgb(58, 180, 209)'
        //             }
        //     }else{
        //         tasks[i].color = 'rgb(122, 209, 58)' 
        //     }



        // }

        // console.warn('subtaskuri toate ', subT)


        let taskuriAll = []

        for (let i = 0; i < counter5; i++) {

            subT[i].utilizator_responsabil = newU.filter(ut => ut.id === subT[i].id_utilizator_responsabil)

            if (subT[i].utilizator_responsabil.length > 0) {

                subT[i].utilizator_responsabil[0]['show_tag_subtask'] = false

            }

            subT[i].nume_proiect = iProiect['titlu']


            let idxE = cloneEtape.findIndex(et => et.id === subT[i].id_etapa_proiect)

            console.log('idxE :>> ', idxE);
            console.log('p :>> ', iProiect);


            if (idxE !== -1) {
                console.log('cloneEtape[idxE] >> ', cloneEtape[idxE])



                subT[i].nume_etapa = cloneEtape[idxE]['denumire']
                subT[i]['etapa_selectata'] = cloneEtape[idxE]

                let idxTSel = tasks.findIndex(t => t.id === subT[i]['id_task_parent'])

                if (idxTSel !== -1) {
                    subT[i]['task_selectat'] = tasks[idxTSel]
                }
            }



            if (subT[i].statusul !== 'Finalizat') {


                let filterSubT = subT.filter(st => st.id_task_parent === subT[i].id)






                if (filterSubT.length > 0) {



                    filterSubT = filterSubT.filter(t => t.statusul !== 'Finalizat')

                    let subTTrecute = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data) <= new Date()))



                    // console.warn('subTTrecute', subTTrecute)

                    // console.warn('subtaskuri', subT.filter(st => st.id_task_parent === subT[i].id))

                    subT[i].subtaskuri = subT.filter(st => st.id_task_parent === subT[i].id)
                    subT[i].subtaskuri_finalizate = subT[i].subtaskuri.filter(st => st.statusul === 'Finalizat')
                    subT[i].subtaskuri_trecute = subTTrecute.length
                    subT[i].show_tag = false
                    subT[i].edit_task = false
                    subT[i].utilizator_view = false
                    subT[i].hide_calendar = true
                    subT[i].hide_calendar_finish = true
                    subT[i].show_change_arrow = false


                    if (subT[i].subtaskuri.length === 0) {
                        subT[i].procent_completare = 100
                    } else {
                        subT[i].procent_completare = (subT[i].subtaskuri_finalizate.length * 100) / subT[i].subtaskuri.length
                    }

                    if (subT[i].subtaskuri_finalizate.length >= 1) {
                        subT[i].color = 'rgb(24 166 59)'
                        subT[i].in_lucru = true
                    } else if (subT[i].subtaskuri.length === subT[i].subtaskuri_trecute) {
                        subT[i].color = 'rgb(252 63 71 )'
                        subT[i].in_lucru = true
                    } else {
                        subT[i].color = 'rgb(209 209 208)'
                        subT[i].in_lucru = false
                    }

                } else {
                    if (new Date(ut.ParseDataFromSql(subT[i].pana_cand_data)) <= new Date()) {
                        // console.log('colorTask :');
                        subT[i].color = 'rgb(252 63 71 )'
                        subT[i].subtaskuri = []
                        subT[i].subtaskuri_finalizate = []
                        subT[i].subtaskuri_trecute = []
                        subT[i].procent_completare = 0
                        subT[i].show_tag = false
                        subT[i].edit_task = false
                        subT[i].utilizator_view = false
                        subT[i].hide_calendar = true
                        subT[i].hide_calendar_finish = true
                        subT[i].in_lucru = false
                        subT[i].show_change_arrow = false
                    } else if (new Date(ut.ParseDataFromSql(subT[i].cand_data)) > new Date()) {
                        subT[i].color = 'rgb(209, 209, 208)'
                        subT[i].subtaskuri = []
                        subT[i].subtaskuri_finalizate = []
                        subT[i].subtaskuri_trecute = []
                        subT[i].procent_completare = 0
                        subT[i].show_tag = false
                        subT[i].edit_task = false
                        subT[i].utilizator_view = false
                        subT[i].hide_calendar = true
                        subT[i].hide_calendar_finish = true
                        subT[i].in_lucru = false
                        subT[i].show_change_arrow = false
                    } else {
                        subT[i].color = 'rgb(209, 209, 208)'
                        subT[i].subtaskuri = []
                        subT[i].subtaskuri_finalizate = []
                        subT[i].subtaskuri_trecute = []
                        subT[i].procent_completare = 0
                        subT[i].show_tag = false
                        subT[i].edit_task = false
                        subT[i].utilizator_view = false
                        subT[i].hide_calendar = true
                        subT[i].hide_calendar_finish = true
                        subT[i].in_lucru = false
                        subT[i].show_change_arrow = false
                    }
                }




            } else {

                let filterSubT = subT.filter(st => st.id_task_parent === subT[i].id)

                if (filterSubT.length > 0) {
                    let subTTrecute = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data) <= new Date()))
                    subT[i].color = 'rgb(24 166 59)'
                    subT[i].subtaskuri = subT.filter(st => st.id_task_parent === subT[i].id)
                    subT[i].subtaskuri_finalizate = subT[i].subtaskuri.filter(st => st.statusul === 'Finalizat')
                    subT[i].subtaskuri_trecute = subTTrecute.length
                    subT[i].procent_completare = 100
                    subT[i].show_tag = false
                    subT[i].edit_task = false
                    subT[i].utilizator_view = false
                    subT[i].hide_calendar = true
                    subT[i].hide_calendar_finish = true
                    subT[i].in_lucru = false
                    subT[i].show_change_arrow = false

                } else {

                    subT[i].color = 'rgb(24 166 59)'
                    subT[i].subtaskuri = []
                    subT[i].subtaskuri_finalizate = []
                    subT[i].subtaskuri_trecute = []
                    subT[i].procent_completare = 100
                    subT[i].show_tag = false
                    subT[i].edit_task = false
                    subT[i].utilizator_view = false
                    subT[i].hide_calendar = true
                    subT[i].hide_calendar_finish = true
                    subT[i].in_lucru = false
                    subT[i].show_change_arrow = false

                }



            }


            taskuriAll.push(subT[i])
        }

        for (let i = 0; i < counter; i++) {

            let idx = newU.findIndex(ut => ut.id === tasks[i].id_utilizator_responsabil)

            tasks[i]['utilizator_responsabil'] = []

            if (idx !== -1) {
                tasks[i]['utilizator_responsabil'] = [{ ...newU[idx] }]
                tasks[i].utilizator_responsabil['show_tag_task'] = false
                tasks[i].utilizator_responsabil['id_task'] = tasks[i].id

            }

            console.log('tasks[i] :>> ', tasks[i]);

            tasks[i].nume_proiect = iProiect['titlu']


            let idxE = cloneEtape.findIndex(et => et.id === tasks[i].id_etapa_proiect)

            console.log('idxE :>> ', idxE);
            console.log('p :>> ', iProiect);


            if (idxE !== -1) {
                console.log('cloneEtape[idxE] >> ', cloneEtape[idxE])

                tasks[i].nume_etapa = cloneEtape[idxE]['denumire']
                tasks[i]['etapa_selectata'] = cloneEtape[idxE]
            }


            // tasks[i].utilizator_responsabil = newU.filter(ut => ut.id === tasks[i].id_utilizator_responsabil)
            // console.log('tasks[i].utilizator_responsabil :>> ', tasks[i].utilizator_responsabil);
            // console.log('tasks[i] :>> ', tasks[i]);

            // if(tasks[i].utilizator_responsabil.length > 0){
            //     // console.log('tasks[i].utilizator_responsabil :>> ', tasks[i].utilizator_responsabil);
            //     tasks[i].utilizator_responsabil[0]['show_tag_task'] = false
            //     tasks[i].utilizator_responsabil[0]['id_task'] = tasks[i].id
            // }



            if (tasks[i].statusul !== 'Finalizat') {

                let filterSubT = subT.filter(st => st.id_task_parent === tasks[i].id)
                // console.warn('filterSubT', filterSubT)

                if (filterSubT.length > 0) {
                    filterSubT = filterSubT.filter(t => t.statusul !== 'Finalizat')

                    let subTTrecute = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date())
                    // let subTInViitor = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date())
                    // if (tasks[i].id === 32) {
                    //     // console.log('filterSubT :', filterSubT);
                    //     // console.log('filterSubT :', subTInViitor);
                    // }

                    tasks[i].subtaskuri = subT.filter(st => st.id_task_parent === tasks[i].id)
                    tasks[i].subtaskuri_finalizate = tasks[i].subtaskuri.filter(st => st.statusul === 'Finalizat')
                    tasks[i].subtaskuri_trecute = subTTrecute.length
                    tasks[i].show_tag = false
                    tasks[i].edit_task = false
                    tasks[i].utilizator_view = false
                    tasks[i].hide_calendar = true
                    tasks[i].hide_calendar_finish = true
                    tasks[i].show_change_arrow = false

                    if (tasks[i].subtaskuri.length === 0) {
                        tasks[i].procent_completare = 100
                    } else {
                        tasks[i].procent_completare = (tasks[i].subtaskuri_finalizate.length * 100) / tasks[i].subtaskuri.length
                    }


                    if (tasks[i].subtaskuri_finalizate.length >= 1) {
                        tasks[i].color = 'rgb(24 166 59)'
                        tasks[i].in_lucru = true
                    } else if (tasks[i].subtaskuri.length === tasks[i].subtaskuri_trecute) {
                        tasks[i].color = 'rgb(252 63 71 )'
                        tasks[i].in_lucru = true
                    }

                    else {
                        tasks[i].color = 'rgb(209 209 208)'
                        tasks[i].in_lucru = false
                    }


                    // if (filterSubT.length > 0) {


                    //     if(subTTrecute.length > 0){
                    //         tasks[i].color = '#'
                    //     }

                    //     // if (subTTrecute.length > 0) {
                    //     //     if (tasks[i].id === 32) {
                    //     //         // console.log('filterSubT :', subTTrecute);
                    //     //     }
                    //     //     tasks[i].color = '#ff3f3f'
                    //     // } else if (filterSubT.length === subTInViitor.length) {

                    //     //     tasks[i].color = 'rgb(58, 180, 209)'
                    //     // } else {
                    //     //     tasks[i].color = 'rgb(251, 141, 0)'
                    //     // }

                    // } else {
                    //     tasks[i].color = 'rgb(122, 209, 58)'
                    // }

                } else {

                    if (new Date(ut.ParseDataFromSql(tasks[i].pana_cand_data)) <= new Date()) {
                        // console.log('colorTask :');
                        tasks[i].color = 'rgb(252 63 71 )'
                        tasks[i].subtaskuri = []
                        tasks[i].subtaskuri_finalizate = []
                        tasks[i].subtaskuri_trecute = []
                        tasks[i].procent_completare = 0
                        tasks[i].show_tag = false
                        tasks[i].edit_task = false
                        tasks[i].utilizator_view = false
                        tasks[i].hide_calendar = true
                        tasks[i].hide_calendar_finish = true
                        tasks[i].in_lucru = false
                        tasks[i].show_change_arrow = false
                    } else if (new Date(ut.ParseDataFromSql(tasks[i].cand_data)) > new Date()) {
                        tasks[i].color = 'rgb(209, 209, 208)'
                        tasks[i].subtaskuri = []
                        tasks[i].subtaskuri_finalizate = []
                        tasks[i].subtaskuri_trecute = []
                        tasks[i].procent_completare = 0
                        tasks[i].show_tag = false
                        tasks[i].edit_task = false
                        tasks[i].utilizator_view = false
                        tasks[i].hide_calendar = true
                        tasks[i].hide_calendar_finish = true
                        tasks[i].in_lucru = false
                        tasks[i].show_change_arrow = false
                    } else {
                        tasks[i].color = 'rgb(209, 209, 208)'
                        tasks[i].subtaskuri = []
                        tasks[i].subtaskuri_finalizate = []
                        tasks[i].subtaskuri_trecute = []
                        tasks[i].procent_completare = 0
                        tasks[i].show_tag = false
                        tasks[i].edit_task = false
                        tasks[i].utilizator_view = false
                        tasks[i].hide_calendar = true
                        tasks[i].hide_calendar_finish = true
                        tasks[i].in_lucru = false
                        tasks[i].show_change_arrow = false
                    }
                }

            } else {

                let filterSubT = subT.filter(st => st.id_task_parent === tasks[i].id)

                if (filterSubT.length > 0) {


                    let subTTrecute = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date())


                    tasks[i].color = 'rgb(24 166 59)'

                    tasks[i].subtaskuri = subT.filter(st => st.id_task_parent === tasks[i].id)
                    tasks[i].subtaskuri_finalizate = tasks[i].subtaskuri.filter(st => st.statusul === 'Finalizat')
                    tasks[i].subtaskuri_trecute = subTTrecute.length
                    tasks[i].procent_completare = 100
                    tasks[i].show_tag = false
                    tasks[i].edit_task = false
                    tasks[i].utilizator_view = false
                    tasks[i].hide_calendar = true
                    tasks[i].hide_calendar_finish = true
                    tasks[i].in_lucru = false
                    tasks[i].show_change_arrow = false

                } else {


                    tasks[i].color = 'rgb(24 166 59)'
                    tasks[i].subtaskuri = []
                    tasks[i].subtaskuri_finalizate = []
                    tasks[i].subtaskuri_trecute = []
                    tasks[i].procent_completare = 100
                    tasks[i].show_tag = false
                    tasks[i].edit_task = false
                    tasks[i].utilizator_view = false
                    tasks[i].hide_calendar = true
                    tasks[i].hide_calendar_finish = true
                    tasks[i].in_lucru = false
                    tasks[i].show_change_arrow = false
                }


            }

            taskuriAll.push(tasks[i])
        }
        // console.warn('tasks :>> ', tasks);

        console.log('taskuriAll :>> ', taskuriAll);
        // console.log('cloneEtape :', cloneEtape);



        let astazi = new Date()

        let inCurand = new Date(new Date().setDate(astazi.getDate() + 7))

        console.log('astazi :>> ', astazi);

        console.log('inCurand :>> ', inCurand);


        let angajatT = []
        console.log('idUser :>> ', ls.GetUserData().InfoUser.IdUser);

        let taskuriAngajat = taskuriAll.filter(t => Number(t.id_utilizator_responsabil) === Number(ls.GetUserData().InfoUser.IdUser))

        console.log('taskuriAngajat :>> ', taskuriAngajat);

        let taskuriAzi = taskuriAngajat.filter(t => this.utils.ParseDataFromSql(t.pana_cand_data) <= this.utils.transformDataForSql(astazi))

        let taskuriInCurand = taskuriAngajat.filter(t => (this.utils.ParseDataFromSql(t.pana_cand_data) > this.utils.transformDataForSql(astazi))
            && this.utils.ParseDataFromSql(t.pana_cand_data) <= this.utils.transformDataForSql(inCurand))

        let taskuriViitor = taskuriAngajat.filter(t => this.utils.ParseDataFromSql(t.pana_cand_data) > this.utils.transformDataForSql(inCurand))


        angajatT.push({ id: 1, title: 'Astazi', tasks: taskuriAzi, show_tasks: true })
        angajatT.push({ id: 2, title: 'In curand', tasks: taskuriInCurand, show_tasks: true })
        angajatT.push({ id: 3, title: 'In viitor', tasks: taskuriViitor, show_tasks: true })


        console.log('angajatT :>> ', angajatT);

        let counter2 = cloneEtape.length

        for (let i = 0; i < counter2; i++) {
            let filterTaskuri = tasks.filter(t => t.id_etapa_proiect === cloneEtape[i].id)

            filterTaskuri = filterTaskuri.filter(t => (new Date(ut.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) && new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(cloneEtape[i].durata_pana_la)))


            filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)


            filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')




            let taskuriTrecute = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date())

            let taskuriInViitor = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date())


            cloneEtape[i].taskuri = tasks.filter(t => t.id_etapa_proiect === cloneEtape[i].id)
            cloneEtape[i].taskuri = cloneEtape[i].taskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(ut.ParseDataFromSql(cloneEtape[i].durata_pana_la)))
            cloneEtape[i].subtaskuri = subT.filter(t => t.id_etapa_proiect === cloneEtape[i].id)
            cloneEtape[i].subtaskuri = cloneEtape[i].subtaskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(ut.ParseDataFromSql(cloneEtape[i].durata_pana_la)))
            cloneEtape[i].taskuri_finalizate = cloneEtape[i].taskuri.filter(t => t.statusul === 'Finalizat')
            cloneEtape[i].taskuri_trecute = taskuriTrecute.length
            cloneEtape[i].show_tag = false



            if (cloneEtape[i].taskuri.length === 0) {
                cloneEtape[i].procent_completare = 100
            } else {
                cloneEtape[i].procent_completare = (cloneEtape[i].taskuri_finalizate.length * 100) / cloneEtape[i].taskuri.length
            }





            if (cloneEtape[i].taskuri_finalizate.length >= 1) {
                cloneEtape[i].color = 'rgb(24 166 59)'
                cloneEtape[i].in_lucru = true
            } else if (cloneEtape[i].taskuri.length === 0) {
                if (new Date(cloneEtape[i].durata_pana_la) < new Date()) {
                    cloneEtape[i].color = 'rgb(252 63 71 )'
                } else {
                    cloneEtape[i].color = 'rgb(225 225 224)'
                    cloneEtape[i].in_lucru = true
                }

            } else {
                if (new Date(cloneEtape[i].durata_pana_la) < new Date()) {
                    cloneEtape[i].color = 'rgb(252 63 71 )'
                } else {
                    cloneEtape[i].color = 'rgb(209 209 208)'
                    cloneEtape[i].in_lucru = false
                }
            }



            // if (filterTaskuri.length > 0) {
            //     if (taskuriTrecute.length > 0) {
            //         cloneEtape[i].color = '#ff3f3f'
            //     } else if (filterTaskuri.length === taskuriInViitor.length) {
            //         cloneEtape[i].color = 'rgb(58, 180, 209)'
            //     } else {
            //         cloneEtape[i].color = 'rgb(251, 141, 0)'
            //     }

            // } else {
            //     cloneEtape[i].color = 'rgb(122, 209, 58)'
            // }



            //     cloneEtape[i].color = '#ff3f3f'
            // }else if (filterTaskuri.length > 0){
            //     cloneEtape[i].color = 'rgb(247, 167, 16)'
            // }else{
            //     cloneEtape[i].color = '#7ad13a'
            // }

        }

        let cloneEtapeAll = [...eA]

        // console.log('cloneEtapeAll :', cloneEtapeAll);


        let cloneTaskuri = [...tA]

        let counter4 = cloneEtapeAll.length



        for (let i = 0; i < counter4; i++) {
            let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtapeAll[i].id)

            filterTaskuri = filterTaskuri.filter(t => (new Date(ut.ParseDataFromSql(t.cand_data)) < new Date(cloneEtapeAll[i].durata_pana_la) && new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(cloneEtapeAll[i].durata_pana_la)))

            // console.warn('filterTaskuri :', filterTaskuri);
            filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)

            filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')




            let taskuriTrecute = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date())

            let taskuriInViitor = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date())



            if (filterTaskuri.length > 0) {
                if (taskuriTrecute.length > 0) {
                    cloneEtapeAll[i].color = 'rgb(252 63 71 )'
                } else if (filterTaskuri.length === taskuriInViitor.length) {
                    cloneEtapeAll[i].color = 'rgb(58, 180, 209)'
                } else {
                    cloneEtapeAll[i].color = 'rgb(251, 141, 0)'
                }

            } else {
                cloneEtapeAll[i].color = 'rgb(122, 209, 58)'
            }



            //     cloneEtape[i].color = '#ff3f3f'
            // }else if (filterTaskuri.length > 0){
            //     cloneEtape[i].color = 'rgb(247, 167, 16)'
            // }else{
            //     cloneEtape[i].color = '#7ad13a'
            // }

        }



        let cloneProiecte = [...p.Content]

        let counter3 = cloneProiecte.length

        let perioadaDeLa = ut.defaultData()

        let perioadaPanaLa = ut.defaultDataPlus3Months();

        for (let i = 0; i < counter3; i++) {


            cloneProiecte[i].perioada_dela = ut.ParseDataFromSql(cloneProiecte[i].perioada_dela)
            cloneProiecte[i].perioada_panala = ut.ParseDataFromSql(cloneProiecte[i].perioada_panala)
        }

        for (let i = 0; i < counter3; i++) {
            if (new Date(cloneProiecte[i].perioada_dela) < new Date(perioadaDeLa)) {
                perioadaDeLa = cloneProiecte[i].perioada_dela
            }

            if (new Date(cloneProiecte[i].perioada_panala) > new Date(perioadaPanaLa)) {
                perioadaPanaLa = cloneProiecte[i].perioada_panala
            }
        }
        // console.warn('etapaSelectatanou :', this.state.objEtapaSelectata);

        // console.warn('cloneEtape :', cloneEtapeAll);




        // console.log('tasks  :', tasks );

        let etapaSelectata = cloneEtape.filter(e => e.id === this.state.objEtapaSelectata.id)

        // console.warn('consoleWarnObjEtapaSelectata :', this.state.objEtapaSelectata);

        // console.log('etapaSelectata :', etapaSelectata);

        let doc

        let etapeDoc = await fS.getDocumenteEtapa(this.state.objEtapaSelectata.id)
        // console.log('etapeDoc :', etapeDoc);
        if (etapeDoc.Succes) {
            doc = etapeDoc.Content

            let docL = doc.length

            for (let i = 0; i < docL; i++) {
                doc[i].cand_uploadat = ut.ParseDataFromSql(doc[i].cand_uploadat)
                doc[i].doc_info = 'Etapa'
            }

            // console.warn('documente etapa', doc)
            // console.log('proiect info ... :', i);



            console.log('cloneEtape :>> ', cloneEtape);

            console.log('i :>> ', i);


            let etapaSelectata

            let idxE = cloneEtape.findIndex(c => c.id === this.state.objEtapaSelectata.id)

            if (idxE !== -1) {
                etapaSelectata = cloneEtape[idxE]
            } else {
                etapaSelectata = this.state.objEtapaSelectata
            }


            console.log('ls.userData :>> ', ls.GetUserData());

            // let alertView = false

            // if (ls.GetUserData().InfoUser.IsAdmin !== 1) {

            //    if(ls.GetUserData().InfoUser.EsteSef !== 1){
            //      alertView = true
            //    }
            // }
            this.setState({
                etape: cloneEtape,
                listTaskuri: tasks,
                listDocumenteEtapa: doc,
                objInfoProiect: i,
                // objEtapaSelectata: etapaSelectata[0],
                listSubTaskuri: subT,
                listEtapeAll: cloneEtapeAll,
                objPerioadaGantt: { dtPerioadaDeLa: perioadaDeLa, dtPerioadaPanaLa: perioadaPanaLa },
                listProiecte: cloneProiecte,
                listTaskuriAll: tA,
                useri: newU,
                angajatView: angajatT,
                objEtapaSelectata: etapaSelectata,
                // alertView: alertView
            },
                () => {
                    // console.log('etapeLength :', this.state.etape.length);
                    // console.log('this.state.objInfoProiect :', this.state.objInfoProiect);
                    // this.getEtapaId()
                })


        }

    }


    insertEtapa = async (e) => {

        // console.log('e :', e);

        let utils = new Utils();
        let fS = new FromServer();


        let objToInsert = {
            id_proiect: this.props.idproiect,
            denumire: e.nume,
            durata_de_la: e.dela,
            durata_pana_la: e.panala,
            id_user_responsabil: this.state.responsabil,
            adaugata_de: 1,
            adaugata_la: utils.defaultData(),

        }


        let insertE = await fS.insertEtapa(objToInsert);

        if (insertE) {
            // console.log('insertOk :', insertE);
            let etape = await fS.getEtape(this.props.idproiect)

            //    console.log('etape :', etape);

            this.setState({ etape: etape })
        }


        // console.log('objToInsert :', objToInsert);


    }

    onEtapaClick = (e, b) => {

        // console.log('e :', e);
        // console.log('b :', b);
        this.setState({
            menuOpen: true,
            elSelectat: b
        })

    }

    avatarClick = (e) => {
        // console.log('e :', e);

        this.setState({
            isOpenMenuAvatar: true,
            elSelectat: e
        })
    }

    etapeClick = () => {
        this.setState({
            isOpenMenuEtape: true
        })
    }

    openUserMenu = () => {
        this.setState({
            isOpenUtilizator: true
        })
    }

    userClickedTask = (t) => {

        let tasks = [...this.state.listTaskuri]

        let idx = tasks.findIndex(tsk => tsk.id === t.id)

        if (idx !== -1) {
            tasks[idx]['utilizator_view'] = true
        }



        this.setState({
            isOpenUtilizator: true,
            listaTaskuri: tasks,
            objInfoTask: t
        })
    }

    userClickedSubTask = (t) => {

        let tasks = [...this.state.listSubTaskuri]

        let idx = tasks.findIndex(tsk => tsk.id === t.id)

        if (idx !== -1) {
            tasks[idx]['utilizator_view'] = true
        }



        this.setState({
            isOpenUtilizator: true,
            listSubTaskuri: tasks,
            objInfoTask: t
        })
    }

    openUserMenuEtapa = () => {
        this.setState({
            isOpenUtilizatorEtapa: true
        })
    }

    changeTitle = async (e, text) => {
        // console.log('changeTitle :', e);
        // console.log('changeTitle :', text);


        let fs = new FromServer();
        let obj = { denumire: text }

        let updateStatus = await fs.updateEtapa(obj, e.id)
        if (updateStatus) {

            let etape = await fs.getEtape(this.props.idproiect)

            this.setState({
                etape: etape
            })

        }
    }


    changeNote = async (e, text) => {
        // console.log('changeTitle :', e);
        // console.log('changeTitle :', text);


        let fs = new FromServer();
        let obj = { denumire: text }

        let updateStatus = await fs.updateEtapa(obj, e.id)
        if (updateStatus) {

            let etape = await fs.getEtape(this.props.idproiect)

            this.setState({
                etape: etape
            })

        }
    }


    changeTimer = async (e, time, kind) => {
        // console.log('e :', e);
        // console.log('time ---2--212-1-21-2--12-12-12-1-2-1:', time);
        // console.log('kind :', kind);


        let fs = new FromServer();

        if (kind === 'dela') {


            let obj = { durata_de_la: time }

            let updateStatus = await fs.updateEtapa(obj, e.id)
            if (updateStatus) {

                let etape = await fs.getEtape(this.props.idproiect)

                this.setState({
                    etape: etape
                })

            }
        } else {
            let obj = { durata_pana_la: time }

            let updateStatus = await fs.updateEtapa(obj, e.id)
            if (updateStatus) {

                let etape = await fs.getEtape(this.props.idproiect)

                this.setState({
                    etape: etape
                })

            }
        }
    }


    closeMenuAvatar = async (e) => {
        // console.log('e :', e);

        let fs = new FromServer();

        // console.warn('update responsabil---s--s-a--d--d-sa---d :', e);

        if (e !== null) {
            let obj = { id_user_responsabil: e.id }

            let updateIdResponsabil = await fs.updateEtapa(obj, this.state.elSelectat.id)
            if (updateIdResponsabil) {

                let etape = await fs.getEtape(this.props.idproiect)

                this.setState({
                    isOpenMenuAvatar: false,
                    etape: etape
                })

            }

        } else {

            this.setState({ isOpenMenuAvatar: false }, () => {
                // console.log('this.state.menuOpen :', this.state.isOpenMenuAvatar);
            })
        }
    }

    closeMenuStatus = async (s) => {

        // console.log('status :', s);

        let fs = new FromServer();



        if (s !== null) {
            let obj = { statusul: s.id }

            let updateStatus = await fs.updateEtapa(obj, this.state.elSelectat.id)
            if (updateStatus) {

                let etape = await fs.getEtape(this.props.idproiect)

                this.setState({
                    menuOpen: false,
                    etape: etape
                })

            }

        } else {

            this.setState({ menuOpen: false }, () => {
                // console.log('this.state.menuOpen :', this.state.menuOpen);
            })
        }
    }

    updateTasks = (t) => {

        let tasks = [...this.state.listTaskuri]

        let idx = tasks.findIndex(tt => tt.id === t.id)

        if (idx !== -1) {
            tasks[idx] = t

            // console.log('tasks :>> ', tasks);

            this.setState({ listTaskuri: tasks })
        }

    }

    updateSubTasks = (t) => {
        let subTasks = [...this.state.listSubTaskuri]

        let idx = subTasks.findIndex(tt => tt.id === t.id)

        if (idx !== -1) {
            subTasks[idx] = t


            this.setState({ listSubTaskuri: subTasks })

        }
    }

    getSubtaskDates = (t, e, dataStart = null, dataFinish = null) => {
        let u = new Utils()
        console.log('e :>> ', e);

        let task = { ...t }
        task['hide_calendar'] = dataStart ? false : true
        task['hide_calendar_finish'] = dataFinish ? false : true

        let taskuri = [...this.state.listSubTaskuri]


        for (let i = 0, n = taskuri.length; i < n; i++) {
            taskuri[i]['hide_calendar'] = true
            taskuri[i]['hide_calendar_finish'] = true
        }

        let idx = taskuri.findIndex(tsk => tsk.id === task.id)

        if (idx !== -1) {
            taskuri[idx] = task
        }



        this.setState({
            objInfoTask: task,
            strDataStart: t.cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: t.pana_cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
            dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),

            objEtapaInfo: e,
            listSubTaskuri: taskuri

        })

    }

    getTaskDates = (t, e, dataStart = null, dataFinish = null) => {

        let u = new Utils()
        console.log('e :>> ', e);

        let task = { ...t }
        task['hide_calendar'] = dataStart ? false : true
        task['hide_calendar_finish'] = dataFinish ? false : true

        let taskuri = [...this.state.listTaskuri]


        for (let i = 0, n = taskuri.length; i < n; i++) {
            taskuri[i]['hide_calendar'] = true
            taskuri[i]['hide_calendar_finish'] = true
        }

        let idx = taskuri.findIndex(tsk => tsk.id === task.id)

        if (idx !== -1) {
            taskuri[idx] = task
        }



        this.setState({
            objInfoTask: task,
            strDataStart: t.cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: t.pana_cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
            dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
            isHiddenCalendar: dataStart ? true : false,
            isHiddenCalendarFinish: dataFinish ? true : false,
            objEtapaInfo: e,
            listTaskuri: taskuri

        })



    }



    getTaskData = async (t, e, slide = false) => {
        console.warn('t :', t);
        console.warn('e :', e);

        let u = new Utils()

        let el = t
        el.descriere = t.descriere || this.dictionary.proiecte.etapeProiect.descriereTask

        // console.warn('el :', el);

        let fs = new FromServer();

        let getTimpiLucru = await fs.getTaskuriTimpiLucru(el.id_utilizator_responsabil, t.id)

        let taskuriDoc = await fs.getDocumenteTask(el.id)


        // console.warn('getTimpiLucru---------------- :', getTimpiLucru);

        if (taskuriDoc.Succes) {
            console.log('taskuriDoc :>> ', taskuriDoc);

            let timpiLucru = getTimpiLucru.Content

            let counter = timpiLucru.length

            for (let i = 0; i < counter; i++) {
                timpiLucru[i].data_introdusa = u.ParseDataFromSql(timpiLucru[i].data_introdusa)
            }
            let doc = taskuriDoc.Content

            let docL = doc.length

            for (let i = 0; i < docL; i++) {
                doc[i].cand_uploadat = u.ParseDataFromSql(doc[i].cand_uploadat)
                doc[i].doc_info = 'Task'
            }



            console.warn("task selectat", t)

           
         

            this.setState({
                isOpenInsertTask: slide === true ? false : true,
                objInfoTask: el,
                strDataStart: t.cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                strDataFinish: t.pana_cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
                dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
                listTimpiLucru: timpiLucru,
                objEtapaInfo: e,
                listDocumenteTask: doc,
                taskSelectatView: t.id_task_parent !== null ? true : false
                // objEtapaSelectata:e
            }, () => {
                this.insertTaskRef.current.openBugetEtapa()

                if(t.statusul === null){
                    t.statusul = 'Finalizat'

                     this.subTaskFinalizat(t)
                }
            })
        }




    }

    getGanttTaskData = (t) => {

        let cloneEtape = [...this.state.etape]

        let idx = cloneEtape.findIndex(e => e.id === t.id_etapa_proiect)

        let u = new Utils()

        let el = t
        el.descriere = t.descriere || this.dictionary.proiecte.etapeProiect.descriereTask

        // console.log('el :', el);
        this.setState({
            objInfoTask: el,
            strDataStart: t.cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: t.pana_cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
            dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
            isOpenInsertTask: true,
            objEtapaInfo: cloneEtape[idx]
        }, () => {
            this.insertTaskRef.current.openBugetEtapa()
        })


    }


    hideCal = () => {

        if (this.state.isHiddenCalendar === false) {
            this.setState({ isHiddenCalendar: true })
        }

        if (this.state.isHiddenCalendarFinish === false) {
            this.setState({ isHiddenCalendarFinish: true })
        }


    }

    dataStartChange = async (ev) => {
        let fs = new FromServer();
        let ws = new Ws()

        let u = new Utils()

        //  console.warn('ev data start----s-da-s-da-sd-a-d-as :', ev);


        console.log('ev data start change:>> ', ev);


        // let myEv = new Date(new Date(this.state.objEtapaInfo.durata_de_la))

        console.log('this.state.objInfoTask :>> ', this.state.objInfoTask);

        let myEv



        let y;
        let m;
        let d;

        if (ev[0]) {
            y = ev[0].getFullYear()
            m = ev[0].getMonth()
            d = ev[0].getDate()

            myEv = ev[0]
        } else {
            y = ev.getFullYear()
            m = ev.getMonth()
            d = ev.getDate()
            myEv = ev
        }


        console.log('m :>> ', m);



        myEv = new Date(myEv).setHours(0)
        myEv = new Date(myEv)

        let durataEtapaDeLa = new Date(this.state.objEtapaInfo.durata_de_la).setHours(0)
        durataEtapaDeLa = new Date(durataEtapaDeLa)

        let durataEtapaPanaLa = new Date(this.state.objEtapaInfo.durata_pana_la).setHours(0)
        durataEtapaPanaLa = new Date(durataEtapaPanaLa)

        // myEv = myEv.setFullYear(y)
        // console.log('myEvfullYear :>> ',new Date(myEv) );
        // myEv = new Date(myEv).setMonth(m)
        // myEv = new Date(myEv).setDate(d)

        // myEv = new Date(myEv)


        console.log('myEv :>> ', myEv);
        console.log('new Date(this.state.objEtapaInfo.durata_de_la) :>> ', new Date(this.state.objEtapaInfo.durata_de_la));
        console.log('objEtapaInfo :>> ', this.state.objEtapaInfo);
        console.log('comparation :>> ', myEv <= new Date(this.state.objEtapaInfo.durata_de_la));


        console.log('ev[1] :>> ', ev[1]);

        if (ev[1]) {
            let dataEv = myEv
            // dataEv = new Date(dataEv.setDate(dataEv.getDate() + 1))

            console.log('dataEv :>> ', dataEv);
            // console.warn('dataEv :', dataEv);
            console.log('this.state.objEtapaInfo :>> ', this.state.objEtapaInfo);

            console.log('new Date(this.state.objEtapaInfo.cand_data) :>> ', new Date(this.state.objEtapaInfo.cand_data));

            if (durataEtapaDeLa <= dataEv && dataEv <= durataEtapaPanaLa) {


                let obj = {
                    cand_data: u.transformDataForSql(ev[0])
                }




                console.warn('obj :', obj);


                let update = await fs.updateTask(obj, this.state.objInfoTask.id)



                if (update) {

                    let updateSubtaskuri = await ws.update('taskuri', obj, { id_task_parent: this.state.objInfoTask.id })

                    if (updateSubtaskuri.Succes) {
                        this.setState({
                            dtDataStart: ev[0],
                            strDataStart: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.cand_data)),
                            isHiddenCalendar: false

                        }, () => {
                            this.dataFinishChange(ev[1])
                            this.getData()
                        })
                        return true

                    }



                }
            } else if (durataEtapaDeLa <= dataEv && dataEv <= durataEtapaPanaLa) {

                // console.log('this.state.objEtapaInfo :>> ', this.state.objEtapaInfo);
                // console.log('dataEv :>> ', dataEv);

                let obj = {
                    cand_data: u.transformDataForSql(ev[0])
                }

                let update = await fs.updateTask(obj, this.state.objInfoTask.id)

                if (update) {

                    let updateSubtaskuri = await ws.update('taskuri', obj, { id_task_parent: this.state.objInfoTask.id })

                    if (updateSubtaskuri.Succes) {

                        this.setState({
                            dtDataStart: ev[0],
                            strDataStart: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.cand_data)),
                            isHiddenCalendar: false

                        }, () => {
                            this.dataFinishChange(ev[1])
                            this.getData()
                        })
                        return true
                    }
                }

            }


            else {


                this.setState({
                    isOpenAlertPerioadaTask: true
                }, () => {
                    // console.log('this.state.dtDataStart :', this.state.dtDataStart);
                })
            }
        } else {


            if (durataEtapaDeLa <= myEv && myEv <= durataEtapaPanaLa) {

                if (ev[0] || ev[1]) {



                    this.setState({
                        dtDataFinish: ev[1],
                        dtDataStart: ev[0]
                    })
                } else {

                    console.warn('ev eveniment :>> ', ev);
                    let obj = {
                        cand_data: u.transformDataForSql(ev)
                    }

                    console.log('this.state.dtDataStart :>> ', this.state.dtDataStart);

                    if (ev > this.state.dtDataFinish) {


                        this.setState({
                            isOpenAlertPerioadaTaskDt: true,
                            mesajAlertDT: this.dictionary.alertDate.dateMsgAlert
                        }, () => {
                            // console.log('this.state.dtDataStart :', this.state.dtDataStart);
                        })

                    } else {
                        let update = await fs.updateTask(obj, this.state.objInfoTask.id)

                        if (update) {
                            this.setState({
                                dtDataFinish: this.state.dtDataFinish,
                                dtDataStart: ev
                            }, () => {
                                this.getData()
                            })
                        }
                    }


                    console.warn('obj :', obj);




                }


            } else {

                this.setState({
                    isOpenAlertPerioadaTask: true
                }, () => {
                    // console.log('this.state.dtDataStart :', this.state.dtDataStart);
                })
            }

        }






    }

    dataFinishChange = async (ev) => {
        let fs = new FromServer();
        let ws = new Ws()
        let u = new Utils()

        console.warn('ev data finish--------------- :', ev);
        console.warn('ev data etapa start', this.state.objEtapaInfo.durata_de_la)
        console.warn('ev data etapa start', new Date(this.state.objEtapaInfo.durata_pana_la))

        // let myEv = ev
        // let durata_de_la = new Date(this.state.objEtapaInfo.durata_de_la) || 



        let myEv = new Date(new Date(this.state.objEtapaInfo.durata_pana_la))


        let y = ev.getFullYear()
        let m = ev.getMonth()
        let d = ev.getDate()



        myEv = myEv.setFullYear(y)
        myEv = new Date(myEv).setMonth(m)
        myEv = new Date(myEv).setDate(d)

        myEv = new Date(myEv)

        console.log('myEv :>> ', myEv);
        console.log('new Date(this.state.objEtapaInfo.durata_pana_la) :>> ', new Date(this.state.objEtapaInfo.durata_pana_la));
        console.log('comparation :>> ', myEv <= new Date(this.state.objEtapaInfo.durata_pana_la));

        if (new Date(this.state.objEtapaInfo.durata_de_la) <= myEv && myEv <= new Date(this.state.objEtapaInfo.durata_pana_la)) {



            console.warn('ev eveniment :>> ', ev);

            let obj = {
                pana_cand_data: u.transformDataForSql(ev)
            }

            console.log('this.state.dtDataStart :>> ', this.state.dtDataStart);

            if (ev < this.state.dtDataStart) {


                this.setState({
                    isOpenAlertPerioadaTaskDt: true,
                    mesajAlertDT: this.dictionary.alertDate.dateMsgAlert
                }, () => {
                    // console.log('this.state.dtDataStart :', this.state.dtDataStart);
                })

            } else {
                let update = await fs.updateTask(obj, this.state.objInfoTask.id)

                if (update) {


                    let updateSubtaskuri = await ws.update('taskuri', obj, { id_task_parent: this.state.objInfoTask.id })

                    if (updateSubtaskuri.Succes) {
                        this.setState({
                            dtDataFinish: ev,
                            strDataFinish: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.pana_cand_data)),
                            // isHiddenCalendarFinish: true

                        }, () => {
                            this.getData()
                        })
                        return true
                    }

                }
            }


            console.warn('obj :', obj);
        } else if (new Date(this.state.objEtapaInfo.cand_data) <= myEv && myEv <= new Date(this.state.objEtapaInfo.pana_cand_data)) {

            console.warn('ev eveniment :>> ', ev);

            let obj = {
                pana_cand_data: u.transformDataForSql(ev)
            }

            console.log('this.state.dtDataStart :>> ', this.state.dtDataStart);

            if (ev < this.state.dtDataStart) {


                this.setState({
                    isOpenAlertPerioadaTaskDt: true,
                    mesajAlertDT: this.dictionary.alertDate.dateMsgAlert
                }, () => {
                    // console.log('this.state.dtDataStart :', this.state.dtDataStart);
                })

            } else {
                let update = await fs.updateTask(obj, this.state.objInfoTask.id)

                if (update) {

                    let updateSubtaskuri = await ws.update('taskuri', obj, { id_task_parent: this.state.objInfoTask.id })


                    if (updateSubtaskuri.Succes) {
                        this.setState({
                            dtDataFinish: ev,
                            strDataFinish: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.pana_cand_data)),
                            // isHiddenCalendarFinish: true

                        }, () => {
                            this.getData()
                        })
                        return true
                    }

                }
            }


            console.warn('obj :', obj);
        }

        else {


            this.setState({
                isOpenAlertPerioadaTask: true
            }, () => {
                // console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }

    updateTaskTitle = () => {
        let fs = new FromServer();

        // console.log('titlu 1  :', this.state.objInfoTask.titlu );

        let obj = {
            titlu: this.state.objInfoTask.titlu
        }

        //  console.log('titlu 2 :', obj.titlu);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getData()
        }
    }

    subTaskFinalizat = async (t) => {
        let fs = new FromServer();

        let ut = new Utils()

        let ls = new LocalStorage()

        let obj = {
            statusul: t.statusul !== 'Finalizat' ? 'Finalizat' : 'In Lucru',
            cand_finalizat: ut.defaultData(),
            cine_finalizat: ls.GetUserData().InfoUser.IdUser
        }

        console.log('t :>> ', t);
        console.log('obj :>> ', obj);

        let dataFinalizare = t.pana_cand_data.split('T')[0]


        if (obj.statusul === 'Finalizat') {
            if (new Date(ut.defaultData()) >= new Date(dataFinalizare)) {
                console.log('openAlert :>> ',);

                this.setState({
                    openAlertIntarziatS: true,
                    objInfoTask: t
                })
            } else {

                let update = await fs.updateTask(obj, t.id)

                console.log('update :>> ', update);

                if (update) {

                    let cloneSubtaskuri = [...this.state.listSubTaskuri]

                    let idx = cloneSubtaskuri.findIndex(f => f.id === t.id)

                    if (idx !== -1) {
                        cloneSubtaskuri[idx].statusul = obj.statusul


                    }

                    let getStatus = cloneSubtaskuri.filter(st => (st.id_task_parent === this.state.objTaskSelectat.id) && (st.statusul !== 'Finalizat'))

                    let status = ''

                    console.log('getStatus :>> ', getStatus);

                    if (getStatus.length > 0) {
                        status = 'In Lucru'
                    } else {
                        status = 'Finalizat'
                    }

                    let objTask = {
                        statusul: status
                    }

                    console.log('objTask :>> ', objTask);
                    let cloneTaskuri = [...this.state.listTaskuri]

                    let idxT = cloneTaskuri.findIndex(tt => tt.id === this.state.objTaskSelectat.id)

                    if (idxT !== -1) {
                        cloneTaskuri[idxT].statusul = objTask.statusul
                    }


                    console.log('this.state.objTaskSelectat :>> ', this.state.objTaskSelectat);

                    let updateTSelectat = await fs.updateTask(objTask, this.state.objTaskSelectat.id)

                    console.log('updateTSelectat :>> ', updateTSelectat);

                    if (updateTSelectat) {
                        console.log('this.state.objEtapaSelectata :>> ', this.state.objEtapaSelectata);



                        let getStatusE = cloneTaskuri.filter(st => (st.id_etapa_proiect === this.state.objEtapaSelectata.id) && (st.statusul !== 'Finalizat'))

                        console.log('getStatusE :>> ', getStatusE);

                        let statusE = ''



                        if (getStatusE.length > 0) {
                            statusE = 'In Lucru'
                        } else {
                            statusE = 'Finalizat'
                        }

                        let etapaSts = {
                            statusul: statusE
                        }

                        let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)

                        if (updateEtapa) {

                            this.getData()
                        }
                    }

                }


            }

        } else {

            let update = await fs.updateTask(obj, t.id)

            console.log('update :>> ', update);

            if (update) {

                let cloneSubtaskuri = [...this.state.listSubTaskuri]

                let idx = cloneSubtaskuri.findIndex(f => f.id === t.id)

                if (idx !== -1) {
                    cloneSubtaskuri[idx].statusul = obj.statusul


                }

                let getStatus = cloneSubtaskuri.filter(st => (st.id_task_parent === this.state.objTaskSelectat.id) && (st.statusul !== 'Finalizat'))

                let status = ''

                console.log('getStatus :>> ', getStatus);

                if (getStatus.length > 0) {
                    status = 'In Lucru'
                } else {
                    status = 'Finalizat'
                }

                let objTask = {
                    statusul: status
                }

                console.log('objTask :>> ', objTask);
                let cloneTaskuri = [...this.state.listTaskuri]

                let idxT = cloneTaskuri.findIndex(tt => tt.id === this.state.objTaskSelectat.id)

                if (idxT !== -1) {
                    cloneTaskuri[idxT].statusul = objTask.statusul
                }


                console.log('this.state.objTaskSelectat :>> ', this.state.objTaskSelectat);

                let updateTSelectat = await fs.updateTask(objTask, this.state.objTaskSelectat.id)

                console.log('updateTSelectat :>> ', updateTSelectat);

                if (updateTSelectat) {
                    console.log('this.state.objEtapaSelectata :>> ', this.state.objEtapaSelectata);



                    let getStatusE = cloneTaskuri.filter(st => (st.id_etapa_proiect === this.state.objEtapaSelectata.id) && (st.statusul !== 'Finalizat'))

                    console.log('getStatusE :>> ', getStatusE);

                    let statusE = ''



                    if (getStatusE.length > 0) {
                        statusE = 'In Lucru'
                    } else {
                        statusE = 'Finalizat'
                    }

                    let etapaSts = {
                        statusul: statusE
                    }

                    let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)

                    if (updateEtapa) {

                        this.getData()
                    }
                }

            }


        }


    }

    finalizeazaSubtaskIntarziat = async () => {
        let fs = new FromServer();

        let ut = new Utils()

        let ls = new LocalStorage()

        let obj = {
            statusul: this.state.objInfoTask.statusul !== 'Finalizat' ? 'Finalizat' : 'In Lucru',
            cand_finalizat: ut.defaultData(),
            cine_finalizat: ls.GetUserData().InfoUser.IdUser,
            explicatie_intarziere: this.state.motivIntarziat
        }

        console.log('t :>> ', this.state.objInfoTask);
        console.log('obj :>> ', obj);

        let update = await fs.updateTask(obj, this.state.objInfoTask.id)

        console.log('update :>> ', update);

        if (update) {

            let cloneSubtaskuri = [...this.state.listSubTaskuri]

            let idx = cloneSubtaskuri.findIndex(f => f.id === this.state.objInfoTask.id)

            if (idx !== -1) {
                cloneSubtaskuri[idx].statusul = obj.statusul


            }

            let getStatus = cloneSubtaskuri.filter(st => (st.id_task_parent === this.state.objTaskSelectat.id) && (st.statusul !== 'Finalizat'))

            let status = ''

            console.log('getStatus :>> ', getStatus);

            if (getStatus.length > 0) {
                status = 'In Lucru'
            } else {
                status = 'Finalizat'
            }

            let objTask = {
                statusul: status
            }

            console.log('objTask :>> ', objTask);
            let cloneTaskuri = [...this.state.listTaskuri]

            let idxT = cloneTaskuri.findIndex(tt => tt.id === this.state.objTaskSelectat.id)

            if (idxT !== -1) {
                cloneTaskuri[idxT].statusul = objTask.statusul
            }


            console.log('this.state.objTaskSelectat :>> ', this.state.objTaskSelectat);

            let updateTSelectat = await fs.updateTask(objTask, this.state.objTaskSelectat.id)

            console.log('updateTSelectat :>> ', updateTSelectat);

            if (updateTSelectat) {
                console.log('this.state.objEtapaSelectata :>> ', this.state.objEtapaSelectata);



                let getStatusE = cloneTaskuri.filter(st => (st.id_etapa_proiect === this.state.objEtapaSelectata.id) && (st.statusul !== 'Finalizat'))

                console.log('getStatusE :>> ', getStatusE);

                let statusE = ''



                if (getStatusE.length > 0) {
                    statusE = 'In Lucru'
                } else {
                    statusE = 'Finalizat'
                }

                let etapaSts = {
                    statusul: statusE
                }

                let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)

                if (updateEtapa) {

                    this.setState({
                        openAlertIntarziatS: false,
                        motivIntarziat: ''
                    })

                    this.getData()
                }
            }

        }

    }

    finalizeazaIntarziat = async () => {

        let fs = new FromServer();

        let ut = new Utils()

        let ls = new LocalStorage()

        let obj = {
            statusul: this.state.objInfoTask.statusul !== 'Finalizat' ? 'Finalizat' : 'In Lucru',
            cand_finalizat: ut.defaultData(),
            cine_finalizat: ls.GetUserData().InfoUser.IdUser,
            explicatie_intarziere: this.state.motivIntarziat
        }



        let update = await fs.updateTask(obj, this.state.objInfoTask.id)

        console.log('update :>> ', update);

        if (update) {

            let cloneTaskuri = [...this.state.listTaskuri]


            let idx = cloneTaskuri.findIndex(f => f.id === this.state.objInfoTask.id)
            console.log('idx :>> ', idx);

            if (idx !== -1) {

                cloneTaskuri[idx].statusul = obj.statusul
            }


            let getStatus = cloneTaskuri.filter(st => st.statusul !== 'Finalizat')

            let status = ''

            if (getStatus.length > 0) {
                status = 'In Lucru'
            } else {
                status = 'Finalizat'
            }


            let etapaSts = {
                statusul: status
            }


            // console.log('filterTaskuri :', filterTaskuri);
            console.log('this.state.objEtapaInfo.id :>> ', this.state.objEtapaSelectata.id);

            let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)



            if (updateEtapa) {

                this.setState({ openAlertIntarziat: false, motivIntarziat: '' }, () => {

                    this.getData()
                })

            }


        }
    }

    taskFinalizat = async (t) => {



        let fs = new FromServer();

        let ut = new Utils()

        let ls = new LocalStorage()

        let obj = {
            statusul: t.statusul !== 'Finalizat' ? 'Finalizat' : 'In Lucru',
            cand_finalizat: ut.defaultData(),
            cine_finalizat: ls.GetUserData().InfoUser.IdUser
        }

        console.log('t :>> ', t);
        console.log('obj :>> ', obj);
        // console.log('this.state.objEta-------s-d-s-d-sd-s-d------dsd-s-sd :', this.state.objEtapaInfo);

        // console.log('titlu :', obj.statusul);


        let dataFinalizare = t.pana_cand_data.split('T')[0]


        if (obj.statusul === 'Finalizat') {
            if (new Date(ut.defaultData()) >= new Date(dataFinalizare)) {
                console.log('openAlert :>> ',);

                this.setState({
                    openAlertIntarziat: true,
                    objInfoTask: t
                })
            } else {
                console.log('finalizeaza :>> ',);

                let update = await fs.updateTask(obj, t.id)

                console.log('update :>> ', update);

                if (update) {

                    let cloneTaskuri = [...this.state.listTaskuri]


                    let idx = cloneTaskuri.findIndex(f => f.id === t.id)
                    console.log('idx :>> ', idx);

                    if (idx !== -1) {

                        cloneTaskuri[idx].statusul = obj.statusul
                    }


                    let getStatus = cloneTaskuri.filter(st => st.statusul !== 'Finalizat')

                    let status = ''

                    if (getStatus.length > 0) {
                        status = 'In Lucru'
                    } else {
                        status = 'Finalizat'
                    }


                    let etapaSts = {
                        statusul: status
                    }


                    // console.log('filterTaskuri :', filterTaskuri);
                    console.log('this.state.objEtapaInfo.id :>> ', this.state.objEtapaSelectata.id);

                    let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)



                    if (updateEtapa) {

                        this.getData()
                    }

                }
            }
        } else {
            console.log('finalizeaza :>> ',);

            let update = await fs.updateTask(obj, t.id)

            console.log('update :>> ', update);

            if (update) {

                let cloneTaskuri = [...this.state.listTaskuri]


                let idx = cloneTaskuri.findIndex(f => f.id === t.id)
                console.log('idx :>> ', idx);

                if (idx !== -1) {

                    cloneTaskuri[idx].statusul = obj.statusul
                }


                let getStatus = cloneTaskuri.filter(st => st.statusul !== 'Finalizat')

                let status = ''

                if (getStatus.length > 0) {
                    status = 'In Lucru'
                } else {
                    status = 'Finalizat'
                }


                let etapaSts = {
                    statusul: status
                }


                // console.log('filterTaskuri :', filterTaskuri);
                console.log('this.state.objEtapaInfo.id :>> ', this.state.objEtapaSelectata.id);

                let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)



                if (updateEtapa) {

                    this.getData()
                }

            }
        }





    }

    updateTaskDescription = () => {
        let fs = new FromServer();

        let obj = {
            descriere: this.state.objInfoTask.descriere
        }

        // console.log('descriere :', obj.descriere);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getData()
        }
    }

    updateExplicatieIntarziere = () => {
        let fs = new FromServer();

        let obj = {
            explicatie_intarziere: this.state.objInfoTask.explicatie_intarziere
        }

        // console.log('descriere :', obj.descriere);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getData()
        }
    }

    updateTaskCandOra = () => {
        let fs = new FromServer();

        let obj = {
            cand_ora: this.state.objInfoTask.cand_ora
        }


        let objTask = this.state.objTaskSelectat

        objTask.cand_ora = obj.cand_ora
        // console.log('titlu :', obj.cand_ora);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {

            this.setState({
                objTaskSelectat: objTask
            })
            this.getData()
        }
    }

    updateTaskPanaCandOra = () => {
        let fs = new FromServer();

        let obj = {
            pana_cand_ora: this.state.objInfoTask.pana_cand_ora
        }

        let objTask = this.state.objTaskSelectat

        objTask.pana_cand_ora = obj.pana_cand_ora

        // console.log('titlu :', obj.pana_cand_ora);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {

            this.setState({
                objTaskSelectat: objTask
            })
            this.getData()
        }
    }

    addNewEtapa = async () => {

        let fS = new FromServer();

        let u = new Utils();

        let ls = new LocalStorage();

        let objToInsert = {
            denumire: this.state.objEtapaInfo.denumire,
            durata_de_la: this.state.objEtapaInfo.durata_de_la,
            durata_pana_la: this.state.objEtapaInfo.durata_pana_la,
            cand_ora: this.state.objEtapaInfo.cand_ora,
            pana_cand_ora: this.state.objEtapaInfo.pana_cand_ora,
            id_proiect: this.props.idproiect,
            id_user_responsabil: ls.GetUserData().InfoUser.IdUser,
            note: this.state.objEtapaInfo.note,
            statusul: ""
        }



        // console.log('objToinsert :', objToInsert);

        let insert = await fS.insertEtapa(objToInsert)

        if (insert.Succes) {

            objToInsert.id = insert.Content[0].id
            this.setState({
                isOpenEtapaInsert: false,
                objEtapaInfo: objToInsert,
                isEtapaOpen: true,
                objEtapaSelectata: { id: objToInsert.id }
            }, () => {
                this.getData()
            })
        }

    }

    addNewTask = async (e) => {
        let fs = new FromServer();

        let ls = new LocalStorage()

        let ws = new Ws();



        // console.log('e :', e);




        let etapa = { ...this.state.objEtapaSelectata }

        let obj = {}



        if (etapa.taskuri.length > 0) {
            let lastTask = etapa.taskuri[etapa.taskuri.length - 1].pana_cand_data

            console.log('durata_pana_la :>> ', etapa.taskuri[etapa.taskuri.length - 1]);
            console.log('lastTask1 :>> ', lastTask);

            if (new Date(new Utils().ParseDataFromSql(lastTask)).getTime() >= new Date(new Utils().ParseDataFromSql(etapa.durata_pana_la)).getTime()) {
                lastTask = etapa.durata_de_la
            }



            console.log('lastTask :>> ', lastTask);

            console.log('etapa :>> ', etapa);


            obj = {
                id_utilizator_responsabil: '',
                titlu: '',
                id_proiect: this.props.idproiect,
                id_etapa_proiect: e.id,
                color: 'rgb(108, 96, 197)',
                statusul: '',
                descriere: '',
                cand_data: new Utils().ParseDataFromSql(lastTask),
                pana_cand_data: new Utils().ParseDataFromSql(lastTask),
          

            }

        } else {
            obj = {
                id_utilizator_responsabil: '',
                titlu: '',
                id_proiect: this.props.idproiect,
                id_etapa_proiect: e.id,
                color: 'rgb(108, 96, 197)',
                statusul: '',
                descriere: '',
                cand_data: new Utils().ParseDataFromSql(etapa.durata_de_la),
                pana_cand_data: new Utils().ParseDataFromSql(etapa.durata_de_la)

            }
        }



        console.log('obj :', obj);

        let insertTask = await fs.insertTask(obj)

        console.warn('insert task 000--00-- :>> ', insertTask);

        if (insertTask.success) {



            // console.log('insertTask :', insertTask);
            obj.id = insertTask.content[0].id
            obj.nume = 'Selecteaza user'
            obj.id_task_parent = null


            this.setState({ isOpenInsertTask: true, objInfoTask: obj, objEtapaInfo: e }, () => {
                this.getData()
                this.getTaskData(obj, e)
            })
        }
    }

    insertSubtask = async (t) => {
        console.log('t :', t);

        let fs = new FromServer();

        let obj = {
            id_task_parent: t.id,
            cand_data: t.cand_data,
            pana_cand_data: t.pana_cand_data,
            titlu: '',
            id_utilizator_responsabil: t.id_utilizator_responsabil,
            id_proiect: t.id_proiect,
            id_etapa_proiect: t.id_etapa_proiect,
            descriere: this.dictionary.proiecte.etapeProiect.descriereTask,
         
        }

        let insertTask = await fs.insertTask(obj)

        if (insertTask.success) {



            // console.log('insertTask :', insertTask);
            obj.id = insertTask.content[0].id
            obj.nume = ''



            this.setState({ isOpenInsertTask: true, objInfoTask: obj, objTaskSelectat: t }, () => {
                this.getData()
                this.getTaskData(obj, this.state.objEtapaInfo)
              
            })
        }
    }

    handleTaskChange = name => ev => {

        console.log('name :>> ', name);
        console.log('ev :>> ', ev);
        let objClone = { ...this.state.objInfoTask }

        objClone[name] = ev.target.value

        this.setState({ objInfoTask: objClone })
    }

    handleEtapaChange = name => ev => {
        let objClone = { ...this.state.objEtapaInfo }

        objClone[name] = ev.target.value

        this.setState({ objEtapaInfo: objClone })
    }

    closeEtape = (e) => {

        let fs = new FromServer();

        // console.log('e :', e);

        if (e !== null) {
            let obj = {
                id_etapa_proiect: e.id
            }

            let update = fs.updateTask(obj, this.state.objInfoTask.id)

            if (update) {
                this.setState({
                    isOpenMenuEtape: false,

                    objEtapaInfo: e
                }, () => {
                    this.getData()
                })
            }
        } else {
            this.setState({ isOpenMenuEtape: false })
        }

    }


    closeUtilizator = async (u) => {

        let fs = new FromServer();
        // console.warn('user clicked:---------', u);
        // console.warn('task data ', this.state.objTaskSelectat)

        let ws = new Ws()

        let taskuri = [...this.state.listTaskuri]
        let subTaskuri = [...this.state.listSubTaskuri]

        for (let i = 0, n = taskuri.length; i < n; i++) {
            taskuri[i]['utilizator_view'] = false
        }


        for (let i = 0, n = subTaskuri.length; i < n; i++) {
            subTaskuri[i]['utilizator_view'] = false
        }

        if (u !== null) {
            let obj = {
                id_utilizator_responsabil: u.id,

            }

            let update = await fs.updateTask(obj, this.state.objInfoTask.id)
            console.log('update :>> ', update);
            if (update) {

                let objCloneTask = { ...this.state.objInfoTask }

                // console.log('objCloneTask :', objCloneTask);




                objCloneTask.nume = u.nume
                objCloneTask.id_utilizator_responsabil = u.id
                objCloneTask.poza = u.poza





                this.setState({
                    listTaskuri: taskuri,
                    listSubTaskuri: subTaskuri,
                    isOpenUtilizator: false,
                    objInfoTask: objCloneTask,
                    // objTaskSelectat: objCloneTask
                }, async () => {
                    //    console.log('isOpenUserMenu :', this.state.isOpenUtilizator);

                    console.log('objCloneTask :>> ', objCloneTask);
                    let email = await ws.getData('ActionsNotifications/TaskNouUser', {
                        idUser: objCloneTask.id_utilizator_responsabil,
                        idTask: objCloneTask.id,
                    })

                    console.warn('email-----------------------', email)
                    this.getData()
                })
            }
        } else {

            console.log('else X :>> ');
            this.setState({
                isOpenUtilizator: false,
                listTaskuri: taskuri,
                listSubTaskuri: subTaskuri,
            }, () => {
                this.getData()
            })
            // console.log('isOpenUserMenu :', this.state.isOpenUtilizator);
        }
    }

    closeUtilizatorEtapa = (u) => {

        let fs = new FromServer();

        let ws = new Ws();
        // console.warn('user clicked:---------', u);
        // console.warn('task data ', this.state.objEtapaSelectata)



        if (u !== null) {
            let obj = {
                id_user_responsabil: u.id,

            }

            if (this.state.isEtapaOpen === true) {
                let update = fs.updateEtapa(obj, this.state.objEtapaInfo.id)
                if (update) {

                    let objCloneEtapa = { ...this.state.objEtapaInfo }

                    objCloneEtapa.nume = u.nume
                    objCloneEtapa.id_utilizator_responsabil = u.id
                    objCloneEtapa.poza = u.poza


                    this.setState({
                        isOpenUtilizatorEtapa: false,
                        objEtapaInfo: objCloneEtapa,
                        objEtapaSelectata: objCloneEtapa
                    }, () => {
                        //    console.log('isOpenUserMenu :', this.state.isOpenUtilizator);


                        this.getData()

                    })
                }

            } else {
                let objCloneEtapa = { ...this.state.objEtapaInfo }
                objCloneEtapa.nume = u.nume
                objCloneEtapa.id_utilizator_responsabil = u.id
                objCloneEtapa.poza = u.poza


                this.setState({
                    isOpenUtilizatorEtapa: false,
                    objEtapaInfo: objCloneEtapa,
                    objEtapaSelectata: objCloneEtapa
                })
            }


        } else {
            this.setState({ isOpenUtilizatorEtapa: false }, () => {

            })
            // console.log('isOpenUserMenu :', this.state.isOpenUtilizator);
        }
    }

    editEtapa = (e) => {

        // console.warn(e)
        this.setState({
            isEtapaOpen: true,
            objEtapaInfo: e
        })
    }

    deleteEtapa = (e) => {
        this.setState({
            isOpenAlertDelete: true,
            strEtapaAlert: this.dictionary.proiecte.etapeProiect.deleteEtapa + ' ' + e.denumire + ' ?',
            objEtapaInfo: e
        })
    }

    saveEtapa = async () => {

        let fs = new FromServer();

        let obj = {
            denumire: this.state.objEtapaInfo.denumire || '',
            note: this.state.objEtapaInfo.note || '',
            cand_ora: this.state.objEtapaInfo.cand_ora || " ",
            pana_cand_ora: this.state.objEtapaInfo.pana_cand_ora || " ",
        }

        let update = await fs.updateEtapa(obj, this.state.objEtapaInfo.id)

        if (update) {
            this.setState({ isEtapaOpen: false }, () => {
                this.getData()
            })
        }
    }


    stergeEtapa = () => {
        let fs = new FromServer();

        let obj = {
            inactiv: 1
        }

        let update = fs.updateEtapa(obj, this.state.objEtapaInfo.id)

        if (update) {
            this.setState({
                isOpenAlertDelete: false,
                monthView: true,
                etapaView: true,
                etapaViewTop: false,
                etapaSelectataView: false,
                taskSelectatView: false,
                objEtapaInfo: { denumire: '', note: '', durata_de_la: new Date(), durata_pana_la: new Date(new Utils().defaultDataPlus7Days()), cand_ora: '00:00', pana_cand_ora: '00:00' },
                etapaSelectata: { id: 0 },

                isEtapaOpen: false
            }, () => {
                this.getData()
            })
        }
    }

    deleteTask = () => {
        let fs = new FromServer();

        let obj = {
            inactiv: 1
        }


        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.setState({ isOpenInsertTask: false, openDeleteTask: false }, () => {

                console.warn('deleted Task :>> ',);
                this.getData()
            })
        }
    }





    dragStart = (e, ev) => {

        // console.log('e :', e);
        this.taskData = e

        let el = ev.target

        setTimeout(() => {
            el.classList.add('pm-hide-dragged-element')
        })

        console.log('myData :', this.taskData);
    }

    dragEndTask = (ev) => {
        let taskDraged = ev.target;

        taskDraged.classList.remove('pm-hide-dragged-element')

        console.log('ev.target :>> ', ev.target);
    }

    dragOverEt = (ev) => {

        ev.stopPropagation();
        ev.preventDefault();



    }

    dropEt = (et) => {
        // console.log('etapa :', et);



        this.updateTaskDrop(et)
    }

    updateTaskDrop = async (et) => {

        let fs = new FromServer();


        let obj = {
            id_etapa_proiect: et.id,
            cand_data: et.durata_de_la,
            pana_cand_data: et.durata_pana_la

        }

        console.log('taskData :>> ', this.taskData);
        console.log('et :>> ', et);
        console.log('objToUpdate :>> ', obj);

        // console.log('this.state.myData :', this.taskData)
        let id = this.taskData.id

        // console.log('id etapa proiect :', obj);

        // console.log('id :', id);


        if (this.taskData.subtaskuri.length > 0) {


            for (let i = 0, n = this.taskData.subtaskuri.length; i < n; i++) {
                await fs.updateTask(obj, this.taskData.subtaskuri[i].id)
            }

        }
        let updateT = fs.updateTask(obj, id)

        if (updateT) {
            this.getData()
        }
        console.log('obj :', obj);
        console.log('id :', id);




    }

    colorChange = (ev) => {
        //   console.log('ev.target.value :', ev.target.value);


        //   console.log('this.state.obtask :', this.state.objInfoTask);

        let fs = new FromServer();

        let cloneTaskuri = [...this.state.listTaskuri]

        let idx = cloneTaskuri.findIndex(c => c.id === this.state.objInfoTask.id)

        cloneTaskuri[idx].color = ev.target.value

        let cloneObjTaskInfo = { ...this.state.objInfoTask }

        cloneObjTaskInfo.color = ev.target.value
        let obj = {
            color: ev.target.value
        }

        let updateTask = fs.updateTask(obj, this.state.objInfoTask.id)

        if (updateTask) {
            this.setState({
                listTaskuri: cloneTaskuri,
                objInfoTask: cloneObjTaskInfo
            }, () => {
                this.getData()
            })
        }


    }

    changeDataStartEtapa = (e) => {
        // console.log('e :', e);

        let cloneObjEtapa = { ...this.state.objEtapaInfo }

        cloneObjEtapa.durata_de_la = e

        this.setState({ objEtapaInfo: cloneObjEtapa })
    }

    changeDataFinishEtapa = (e) => {
        // console.log('e :', e);

        let cloneObjEtapa = { ...this.state.objEtapaInfo }

        cloneObjEtapa.durata_pana_la = e

        this.setState({ objEtapaInfo: cloneObjEtapa })
    }

    changeViewEtape = (is, e, idx) => {
        //   console.log('e :', e);
        //   console.log('is :', is);

        // console.log('e :>> ', e);

        this.setState({
            monthView: is,
            objEtapaSelectata: e,
            indexEtapa: idx,
            etapaViewTop: is === false ? true : false,
            taskSelectatView: false,
            etapaSelectataView: is === false ? true : false,
        })
    }

    changeTaskView = (t) => {

        console.clear()
        console.log('this.state.objEtapaSelectata :>> ', this.state.objEtapaSelectata);
        console.log('t :', t);


        console.log('goToTASk :>> ');
        console.log('this.state.listTaskuri :>> ', this.state.listTaskuri);

        let objE = { ...this.state.objEtapaInfo }

        objE['durata_de_la'] = t['cand_data']
        objE['durata_pana_la'] = t['pana_cand_data']
        console.log('objE :>> ', objE);

        this.setState({
            objTaskSelectat: t,
            siteMapArray: this.siteMapArray,
            taskSelectatView: true,
            etapaSelectataView: true,
            objEtapaInfo: objE
        }, () => {
            let el = document.getElementById('subtaskuri-container')

            el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });


            this.generateSiteMap()

            // alert(this.siteMapArray.reverse().join('-'))
            // alert(this.currentParent)
        })



    }



    siteMapArray = []
    currentParent = -1


    generateSiteMap = () => {


        this.siteMapArray = []
        this.identificaPozitieTaskInIerarhie()

        for (let i = 0; i < 100; i++) {

            this.populateSiteMap()
        }

        this.setState({ siteMapArray: this.siteMapArray })
    }

    identificaPozitieTaskInIerarhie = (lista) => {

        let taskuri = lista || this.state.listTaskuri

        let notFound = true



        for (let i = 0, n = taskuri.length; i < n; i++) {


            // for(let j = 0 , m = taskuri.subtaskuri.length; j<m ; j++){

            // }

            if (taskuri[i].id === this.state.objTaskSelectat.id) {

                this.siteMapArray.unshift(taskuri[i])
                this.currentParent = taskuri[i].id_task_parent
                notFound = false
            }


            if (notFound) {
                this.identificaPozitieTaskInIerarhie(taskuri[i].subtaskuri)
            }
        }




    }

    populateSiteMap = (lista) => {

        let taskuri = lista || this.state.listTaskuri


        if (this.currentParent) {

            for (let i = 0, n = taskuri.length; i < n; i++) {


                if (taskuri[i].id === this.currentParent) {

                    this.siteMapArray.unshift(taskuri[i])
                    this.currentParent = taskuri[i].id_task_parent


                }


                this.populateSiteMap(taskuri[i].subtaskuri)

            }

        }




    }




    goToTaskView = (t, e,) => {


        console.log('e :>> ', e);
        this.setState({
            monthView: false,

            objEtapaSelectata: e,
            etapaViewTop: true,
            taskSelectatView: true,
            etapaSelectataView: false,
            objTaskSelectat: t,
            etapaView: false
        })
    }

    openTimpEstimatLucru = () => {
        this.setState({ isOpenTimpiLucru: true })
    }

    openListDocumente = () => {
        this.setState({ isOpenListDocumente: true })
    }

    changeDate = (e, ev) => {
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].data_introdusa = ev.target.value
        this.setState({
            listTimpiLucru: cloneTimpi
        })
    }

    updateDateTimpi = async (t) => {


        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru', { data_introdusa: t.data_introdusa }, { id: t.id })
        if (updateDateTimpi.Succes) {
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata)
        }
    }

    changeOreTimpi = (e, ev) => {
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].nr_ore = ev.target.value
        this.setState({
            listTimpiLucru: cloneTimpi
        })
    }

    updateOreTimpi = async (t) => {
        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru', { nr_ore: t.nr_ore }, { id: t.id })
        if (updateDateTimpi.Succes) {
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata)
        }
    }

    changeMinuteTimpi = (e, ev) => {
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].nr_minute = ev.target.value
        this.setState({
            listTimpiLucru: cloneTimpi
        })
    }

    updateMinuteTimpi = async (t) => {
        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru', { nr_minute: t.nr_minute }, { id: t.id })
        if (updateDateTimpi.Succes) {
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata)
        }
    }

    changeTimpLucruData = n => ev => {

        let cloneTimpLucru = { ...this.state.objTimpLucru }

        cloneTimpLucru[n] = ev.target.value

        this.setState({ objTimpLucru: cloneTimpLucru })

    }

    insertTimpLucru = async (t) => {
        // console.log('t :', t);

        let ws = new Ws();


        let objToInsert = {
            id_user: this.state.objInfoTask.id_utilizator_responsabil,
            data_introducerii: new Utils().defaultData(),
            nr_ore: t.nr_ore,
            id_task: this.state.objInfoTask.id,
            nr_minute: t.nr_minute,
            zile_cumulate: t.zile_cumulate,
            data_introdusa: t.data_introdusa
        }

        let insert = await ws.insert('taskuri_timpi_lucru', objToInsert)

        if (insert.Succes) {
            this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata)
        }
    }

    changeZileCumulate = (ev) => {

        let cloneTimpi = { ...this.state.objTimpLucru }


        cloneTimpi.zile_cumulate = ev.target.checked === true ? 1 : 0

        this.setState({ objTimpLucru: cloneTimpi })

    }

    deleteTimp = async (t) => {
        let ws = new Ws();

        let deleteTimp = await ws.update('taskuri_timpi_lucru', { sters: 1 }, { id: t.id })

        if (deleteTimp.Succes) {
            this.getTaskData(this.state.objInfoTask, this.state.objEtapaInfo)
        }
    }

    goToUser = () => {



        this.props.history.push(`/infouser/${this.state.objUser.id}`)

    }


    changeUser = (ev) => {

        // console.log('ev.target.value :', ev.target.value);
        this.props.history.push(`/userprojects/${ev.target.value}`)
    }





    deleteTaskFile = (f) => {
        this.setState({
            objTaskFile: f,
            isOpenAlertTaskDocument: true
        })
    }

    deleteEtapaFile = (f) => {
        this.setState({
            objEtapaFile: f,
            isOpenAlertEtapaDocument: true
        })
    }

    deleteDocEtapa = async () => {

        let ws = new Ws();

        let ls = new LocalStorage()
        let u = new Utils()

        // console.log('objEtapaFile :', this.state.objEtapaFile);
        let deleteFile = await ws.update('etape_documente', {
            sters: 1,
            cand_sters: u.defaultData(),
            cine_sters: ls.GetUserData().InfoUser.IdUser
        },
            { id: this.state.objEtapaFile.id })
        if (deleteFile.Succes) {

            this.setState({
                isOpenAlertEtapaDocument: false
            }, () => {
                this.getData()
            })

        }

    }

    deleteDoc = async () => {

        let ws = new Ws();

        let ls = new LocalStorage()
        let u = new Utils()

        let deleteFile = await ws.update('taskuri_documente', {
            sters: 1,
            cand_sters: u.defaultData(),
            cine_sters: ls.GetUserData().InfoUser.IdUser
        },
            { id: this.state.objTaskFile.id })
        if (deleteFile.Succes) {

            this.setState({
                isOpenAlertTaskDocument: false
            }, () => {
                this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata)
            })

        }

    }

    closeTaskDialog = () => {

        if (this.state.strDataStart !== this.dictionary.proiecte.etapeProiect.selectDate && this.state.strDataFinish !== this.dictionary.proiecte.etapeProiect.selectDate) {

            console.log('no delete :>> ');
            this.setState({
                isOpenInsertTask: false,
                objInfoTask: { statusul: '', titlu: this.dictionary.proiecte.etapeProiect.numeTask, nume: '', cand_ora: '00:00', pana_cand_ora: '00:00', descriere: this.dictionary.proiecte.etapeProiect.descriereTask, color: '' },
                dtDataStart: new Date(),
                dtDataFinish: new Date(),
                strDataStart: this.dictionary.proiecte.etapeProiect.selectDate,
                strDataFinish: this.dictionary.proiecte.etapeProiect.selectDate,
            },

                async () => { await this.getData() }

            )
        }
        else {

            console.log('deleteTask :>> ');
            this.deleteTask()
        }
    }

    getPerioada = () => {
        this.setState({
            isHiddenCalendar: this.state.isHiddenCalendar ? false : true,
            isHiddenCalendarFinish: this.state.isHiddenCalendarFinish ? false : true
        })
    }


    showTag = (e, idxE) => {
        // console.log('e :>> ', e);

        let cloneEtape = [...this.state.etape]



        let idx = cloneEtape.findIndex(et => et.id === e.id)

        if (idx !== -1) {
            cloneEtape[idx].show_tag = true

            this.setState({ etape: cloneEtape })
        }
    }


    hideTag = (e) => {
        // console.log('e :>> ', e);

        let cloneEtape = [...this.state.etape]

        let idx = cloneEtape.findIndex(et => et.id === e.id)

        if (idx !== -1) {
            cloneEtape[idx].show_tag = false

            this.setState({ etape: cloneEtape })
        }
    }


    showTagTask = (t) => {


        // console.warn('taasaasadadassadsadadsd :>> ', t);
        let cloneTaskuri = [...this.state.listTaskuri]

        // console.warn('cloneTaskuri', cloneTaskuri)

        let idx = cloneTaskuri.findIndex(tsk => tsk.id === t.id)

        // console.log('idx :>> ', idx);

        if (idx !== -1) {
            cloneTaskuri[idx].show_tag = true

            this.setState({ listTaskuri: cloneTaskuri })

        }
    }

    hideTagTask = (t) => {
        let cloneTaskuri = [...this.state.listTaskuri]

        let idx = cloneTaskuri.findIndex(tsk => tsk.id === t.id)

        if (idx !== -1) {
            cloneTaskuri[idx].show_tag = false

            this.setState({ listTaskuri: cloneTaskuri })

        }
    }

    showSubTaskTagTask = (st) => {
        let cloneSubtaskuri = [...this.state.listSubTaskuri]

        let idx = cloneSubtaskuri.findIndex(stsk => stsk.id === st.id)

        if (idx !== -1) {
            cloneSubtaskuri[idx].show_tag = true
            this.setState({ listSubTaskuri: cloneSubtaskuri })
        }

    }

    hideSubTaskTagTask = (st) => {
        let cloneSubtaskuri = [...this.state.listSubTaskuri]

        let idx = cloneSubtaskuri.findIndex(stsk => stsk.id === st.id)

        if (idx !== -1) {
            cloneSubtaskuri[idx].show_tag = false
            this.setState({ listSubTaskuri: cloneSubtaskuri })

        }

    }

    showUserTag = (u) => {

        let cloneUseri = [...this.state.useri]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = true

            this.setState({ useri: cloneUseri })
        }

    }

    hideUserTag = (u) => {
        let cloneUseri = [...this.state.useri]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = false

            this.setState({ useri: cloneUseri })
        }
    }

    showUserTagTask = (t) => {
        console.log('t :>> ', t);

        let tasks = [...this.state.listTaskuri]

        let idx = tasks.findIndex(tt => tt.id === t.id)

        console.log('tasksidx :>> ', tasks[idx]);

        if (idx !== -1) {

            tasks[idx]['utilizator_responsabil'][0].show_tag_task = true

            console.log('task hover :>> ', tasks[idx]['utilizator_responsabil'][0].show_tag_task);

            console.log('tasks :>> ', tasks);

            this.setState({ listaTaskuri: tasks })
        }
    }

    hideUserTagTask = (t) => {

        // console.log('t :>> ', t);

        let tasks = [...this.state.listTaskuri]

        let idx = tasks.findIndex(tt => tt.id === t.id)

        if (idx !== -1) {

            tasks[idx]['utilizator_responsabil'][0].show_tag_task = false

            this.setState({ listaTaskuri: tasks })
        }

    }

    showUserTagSubtask = (t) => {
        let subTasks = [...this.state.listSubTaskuri]

        let idx = subTasks.findIndex(tt => tt.id === t.id)

        console.log('subTasks :>> ', subTasks);

        if (idx !== -1) {
            console.log('showUserTagSubtask :>> ', subTasks[idx]);
            subTasks[idx]['utilizator_responsabil'][0].show_tag_subtask = true

            this.setState({ listSubTaskuri: subTasks })
        }
    }

    hideUserTagSubtask = (t) => {
        let subTasks = [...this.state.listSubTaskuri]

        let idx = subTasks.findIndex(tt => tt.id === t.id)

        if (idx !== -1) {
            subTasks[idx]['utilizator_responsabil'][0].show_tag_subtask = false

            this.setState({ listSubTaskuri: subTasks })
        }
    }
    showChangeArrow = (t) => {

        // console.warn('task selectat to change :>> ', t);

        if (t) {
            let taskuri = [...this.state.listTaskuri]

            let idx = taskuri.findIndex(tt => tt.id === t.id)

            if (idx !== -1) {
                taskuri[idx].show_change_arrow = true

                this.setState({ listTaskuri: taskuri })
            }
        }



    }


    hideChangeArrow = async(t) => {
        // console.warn('task selectat to change :>> ', t);

        let taskuri = [...this.state.listTaskuri]

        let idx = taskuri.findIndex(tt => tt.id === t.id)

        if (idx !== -1) {
            taskuri[idx].show_change_arrow = false

            console.warn('task selectat to change  :>> ', t);

            let updateSubtaskuri = await this.ws.update('taskuri', {cand_data:t.cand_data, 
                                                                    pana_cand_data:t.pana_cand_data}, 
                                                                    {id_task_parent:t.id})


            if(updateSubtaskuri.Succes){

                for(let i = 0 , n = taskuri[idx]['subtaskuri'].length ; i < n ; i++){
                    taskuri[idx]['subtaskuri'][i].cand_data = t.cand_data
                    taskuri[idx]['subtaskuri'][i].pana_cand_data = t.pana_cand_data
                }



                this.setState({ listTaskuri: taskuri }, ()=>{
                    this.changeTaskView(t)
                })
            }

        }
    }


    showSubtaskChangeArrow = (t) => {
        if (t) {
            let subTaskuri = [...this.state.listSubTaskuri]

            let idx = subTaskuri.findIndex(tt => tt.id === t.id)

            if (idx !== -1) {
                subTaskuri[idx].show_change_arrow = true

                this.setState({ listSubTaskuri: subTaskuri })
            }
        }
    }


    hideSubtaskChangeArrow = (t) => {
        if (t) {
            let subTaskuri = [...this.state.listSubTaskuri]

            let idx = subTaskuri.findIndex(tt => tt.id === t.id)

            if (idx !== -1) {
                subTaskuri[idx].show_change_arrow = false

                this.setState({ listSubTaskuri: subTaskuri })
            }
        }
    }

    goToInfoProiect = () => {
        this.props.history.push(`/newproject/${this.props.idproiect}`)
    }


    changeResponsabil = (ev) => {

    }


    changeViewTabel = (tip) => {

        if (tip === 'tabel') {
            this.setState({
                tableView: true,
                thinkView: false,
                ganttView: false
            })
        } else if (tip === 'gantt') {
            this.setState({
                tableView: false,
                thinkView: false,
                ganttView: true
            })
        } else {
            this.setState({
                tableView: false,
                thinkView: true,
                ganttView: false
            })
        }

    }


    changeTask = (ev, t) => {
        let v = ev.target.value
        let n = ev.target.name

        let taskuri = [...this.state.listTaskuri]

        let idx = taskuri.findIndex(tsk => tsk.id === t.id)

        if (idx !== -1) {
            taskuri[idx][n] = v

            this.setState({
                listTaskuri: taskuri,
                objInfoTask: t
            })
        }
    }


    changeSubTask = (ev, t) => {
        let v = ev.target.value
        let n = ev.target.name

        let taskuri = [...this.state.listSubTaskuri]

        let idx = taskuri.findIndex(tsk => tsk.id === t.id)

        if (idx !== -1) {
            taskuri[idx][n] = v

            this.setState({
                listSubTaskuri: taskuri,
                objInfoTask: t
            })
        }
    }


    showTasksAngajat = (id) => {

        let taskuriAngajat = [...this.state.angajatView]

        let idx = taskuriAngajat.findIndex(i => i.id === id)

        if (idx !== -1) {
            taskuriAngajat[idx]['show_tasks'] = !taskuriAngajat[idx]['show_tasks']
        }

        this.setState({ angajatView: taskuriAngajat })
    }


    finalizeazaTaskAngajat = (t) => {
        console.log('t :>> ', t);

        if (!t.id_task_parent) {
            this.setState({
                objEtapaSelectata: t.etapa_selectata,
                objTaskSelectat: t
            }, () => {

                this.taskFinalizat(t)
            })
        } else {

            this.setState({
                objEtapaSelectata: t.etapa_selectata,
                objTaskSelectat: t.task_selectat
            }, () => {
                this.subTaskFinalizat(t)
            })
        }
    }



    clearAngajat = async () => {


        if (this.state.objUser.drepturi_access.acces_extins_proiecte) {
            let ws = new Ws()

            let objTask = { ...this.state.objInfoTask }

            console.log('objTask :>> ', objTask);


            objTask['nume'] = 'Selecteaza user'
            objTask['id_utilizator_responsabil'] = ''
            objTask['poza'] = ''


            let updateTask = await ws.update('taskuri', { id_utilizator_responsabil: 0 }, { id: objTask.id })


            if (updateTask.Succes) {

                this.setState({ objInfoTask: objTask })
            }
        }




    }
    render() {
        return (


            <div style={{ marginTop: 20, height: '88vh', overflow: this.state.thinkView ? 'hidden' : 'scroll' }}>


                <div style={{ width: '100%', overflow: 'scroll', position: 'relative' }}>
                    <div style={{ marginTop: 20, textAlign: 'left', height: '100%', display: 'flex', position: 'absolute' }}>
                        {/* <Fab  onClick={()=>{this.setState({openInsert:true})}} className="pm-round-button">
                                      <i className='material-icons pm-round-button-text'>add</i>
                            </Fab> */}

                        <AlertIntarziereTask
                            open={this.state.openAlertIntarziat}
                            dialogClose={() => { this.setState({ openAlertIntarziat: false, motivIntarziat: '' }) }}
                            updateTask={this.finalizeazaIntarziat}
                            motivIntarziere={this.state.motivIntarziat}
                            changeMotiv={(ev) => { this.setState({ motivIntarziat: ev.target.value }) }}
                        />

                        <AlertIntarziereTask
                            open={this.state.openAlertIntarziatS}
                            dialogClose={() => { this.setState({ openAlertIntarziatS: false, motivIntarziat: '' }) }}
                            updateTask={this.finalizeazaSubtaskIntarziat}
                            motivIntarziere={this.state.motivIntarziat}
                            changeMotiv={(ev) => { this.setState({ motivIntarziat: ev.target.value }) }}
                        />

                        <AlertDialog
                            open={this.state.isOpenAlertPerioadaTask}
                            dialogClose={() => { this.setState({ isOpenAlertPerioadaTask: false }) }}
                            title={this.dictionary.alertDate.task}
                            limba={this.dictionary}
                            yesFunction={() => { this.setState({ isOpenAlertPerioadaTask: false }) }}
                            noButtonDisplay={1}
                        />




                        <AlertNew
                            open={this.state.openDeleteTask}
                            dialogClose={() => { this.setState({ openDeleteTask: false }) }}
                            title={this.dictionary.proiecte.deleteTask}
                            mesaj={this.dictionary.proiecte.deleteTaskMessage}
                            yesFunction={this.deleteTask}
                        />


                        <AlertNew
                            open={this.state.alertView}
                            dialogClose={() => { this.setState({ alertView: false }) }}
                            title={this.dictionary.proiecte.alertView}
                            mesaj={this.dictionary.proiecte.alertViewMessage}
                            noButtonDisplay={1}
                            yesFunction={() => { this.props.history.push('/') }}
                            fullScreen={true}
                        />
                        <AlertDialog
                            open={this.state.isOpenAlertPerioadaTaskDt}
                            dialogClose={() => { this.setState({ isOpenAlertPerioadaTaskDt: false }) }}
                            title={this.state.mesajAlertDT}
                            limba={this.dictionary}
                            yesFunction={() => { this.setState({ isOpenAlertPerioadaTaskDt: false }) }}
                            noButtonDisplay={1}
                        />

                        <EtapeDocumente

                            open={this.state.isOpenListDocumenteE}
                            dialogClose={() => { this.setState({ isOpenListDocumenteE: false }) }}
                            dictionary={this.dictionary}
                            idEtapa={this.state.objEtapaInfo.id}
                            idProiect={this.props.idproiect}
                            listDocumente={this.state.listDocumenteEtapa}
                            deleteFile={this.deleteEtapaFile}
                            deleteDoc={this.deleteDocEtapa}
                            isOpenAlert={this.state.isOpenAlertEtapaDocument}
                            dialogCloseAlert={() => { this.setState({ isOpenAlertEtapaDocument: false }) }}
                            getData={this.getData} />





                        <TaskuriDocumente
                            open={this.state.isOpenListDocumente}
                            dialogClose={() => { this.setState({ isOpenListDocumente: false }) }}
                            dictionary={this.dictionary}
                            idtask={this.state.objInfoTask.id}
                            idProiect={this.props.idproiect}
                            listDocumente={this.state.listDocumenteTask}
                            deleteFile={this.deleteTaskFile}
                            deleteDoc={this.deleteDoc}
                            isOpenAlert={this.state.isOpenAlertTaskDocument}
                            dialogCloseAlert={() => { this.setState({ isOpenAlertTaskDocument: false }) }}
                            getTaskData={() => { this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata) }} />




                        <TimpiLucru
                            open={this.state.isOpenTimpiLucru}
                            dialogClose={() => { this.setState({ isOpenTimpiLucru: false }) }}
                            task={this.state.objInfoTask}
                            getTimpiLucru={() => { this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata) }}
                            timpiLucru={this.state.listTimpiLucru}
                            changeDate={this.changeDate}
                            updateDateTimpi={this.updateDateTimpi}
                            limba={this.dictionary}
                            timpLucru={this.state.objTimpLucru}
                            changeData={this.changeTimpLucruData}
                            insertTimpLucru={this.insertTimpLucru}
                            changeOreTimpi={this.changeOreTimpi}
                            updateOreTimpi={this.updateOreTimpi}
                            changeMinuteTimpi={this.changeMinuteTimpi}
                            updateMinuteTimpi={this.updateMinuteTimpi}
                            changeZileCumulate={this.changeZileCumulate}
                            deleteTimp={this.deleteTimp}

                        />

                        <InsertUpdateTask
                            open={this.state.isOpenInsertTask}
                            dialogClose={this.closeTaskDialog}
                            taskCompletat={this.state.objInfoTask.statusul}
                            taskFinalizat={this.taskFinalizat}
                            dictionary={this.dictionary}
                            dataStart={this.state.strDataStart}
                            dataFinish={this.state.strDataFinish}
                            dtDataStart={this.state.dtDataStart}
                            dtDataFinish={this.state.dtDataFinish}
                            hideCalendarFinish={this.state.isHiddenCalendarFinish}
                            hideCalendar={this.state.isHiddenCalendar}
                            getPerioada={this.getPerioada}
                            showCalendarStart={() => { this.setState({ isHiddenCalendar: this.state.isHiddenCalendar ? false : true, isHiddenCalendarFinish: this.state.isHiddenCalendar ? false : true }) }}
                            showCalendarFinish={() => { this.setState({ isHiddenCalendarFinish: this.state.isHiddenCalendarFinish ? false : true, isHiddenCalendar: true }) }}
                            hideCal={this.hideCal}
                            changeResponsabil={this.changeResponsabil}
                            dataStartChange={(ev) => { this.dataStartChange(ev) }}
                            dataFinishChange={(ev) => { this.dataFinishChange(ev) }}
                            taskTitle={this.state.objInfoTask.titlu}
                            taskTitleChange={this.handleTaskChange('titlu')}
                            updateTaskTitle={this.updateTaskTitle}
                            listEtape={this.state.etape}
                            listTaskuri={this.state.listTaskuri}
                            getData={this.getData}
                            isOpenMenuEtape={this.state.isOpenMenuEtape}
                            closeMenuEtape={this.closeEtape}
                            etapaTitle={this.state.objEtapaInfo.denumire}
                            etapeClick={this.etapeClick}
                            objInfoTask={this.state.objInfoTask}
                            listUsers={this.state.useri}
                            isUtlizatorOpen={this.state.isOpenUtilizator}
                            closeUtilizator={this.closeUtilizator}
                            userClick={this.openUserMenu}
                            listSubTaskuri={this.state.listSubTaskuri}
                            candOra={this.state.objInfoTask.cand_ora}
                            candOraChange={this.handleTaskChange('cand_ora')}
                            panaCandOra={this.state.objInfoTask.pana_cand_ora}
                            panaCandOraChange={this.handleTaskChange('pana_cand_ora')}
                            updateTaskCandOra={this.updateTaskCandOra}
                            updateTaskPanaCandOra={this.updateTaskPanaCandOra}
                            taskDescription={this.state.objInfoTask.descriere}
                            taskDescriptionChange={this.handleTaskChange('descriere')}
                            updateTaskDescription={this.updateTaskDescription}
                            openDeleteTask={() => { this.setState({ openDeleteTask: true }) }}
                            deleteTask={this.deleteTask}
                            colorChange={this.colorChange}
                            culoriTaskuri={this.state.culoriTaskuri}
                            openListTimpEstimatLucru={this.openTimpEstimatLucru}
                            openListDocumente={this.openListDocumente}
                            etapaInfo={this.state.objEtapaInfo}
                            listDocumente={this.state.listDocumenteTask}
                            getTaskData={() => { this.getTaskData(this.state.objInfoTask, this.state.objEtapaSelectata) }}
                            proiectInfo={this.state.objInfoProiect}
                            explicatieIntarziere={this.state.objInfoTask.explicatie_intarziere}
                            explicatieIntarziereChange={this.handleTaskChange('explicatie_intarziere')}
                            updateExplicatieIntarziere={this.updateExplicatieIntarziere}
                            ref={this.insertTaskRef}
                            readOnly={!this.state.objUser.drepturi_access.acces_extins_proiecte}
                            clearAngajat={this.clearAngajat}

                        />


                        <InsertUpdateEtapa
                            open={this.state.isEtapaOpen}
                            candOra={this.state.objEtapaInfo.cand_ora}
                            candOraChange={this.handleEtapaChange('cand_ora')}
                            panaCandOra={this.state.objEtapaInfo.pana_cand_ora}
                            panaCandOraChange={this.handleEtapaChange('pana_cand_ora')}

                            openListDocumente={() => { this.setState({ isOpenListDocumenteE: true }, () => { this.getData() }) }}
                            listUsers={this.state.useri}
                            isUtlizatorOpen={this.state.isOpenUtilizatorEtapa}
                            closeUtilizator={this.closeUtilizatorEtapa}
                            userClick={this.openUserMenuEtapa}
                            dialogClose={() => { this.setState({ isEtapaOpen: false, objEtapaInfo: { denumire: '', note: '', durata_pana_la: null, durata_de_la: new Date() }, }) }}
                            dictionary={this.dictionary}
                            numeEtapa={this.state.objEtapaInfo.denumire}
                            descriereEtapa={this.state.objEtapaInfo.note}
                            numeEtapaChange={this.handleEtapaChange('denumire')}
                            descriereEtapaChange={this.handleEtapaChange('note')}
                            salveazaEtapa={this.saveEtapa}
                            etapaSelectata={this.state.objEtapaInfo}
                            proiectInfo={this.state.objInfoProiect}
                            etape={this.state.etape}
                            getData={this.getData}
                            changeDataStart={this.changeDataStartEtapa}
                            changeDataFinish={this.changeDataFinishEtapa}
                            stergeEtapa={this.stergeEtapa}
                        />

                        <InsertUpdateEtapa
                            open={this.state.isOpenEtapaInsert}
                            candOra={this.state.objEtapaInfo.cand_ora}
                            candOraChange={this.handleEtapaChange('cand_ora')}
                            panaCandOra={this.state.objEtapaInfo.pana_cand_ora}
                            panaCandOraChange={this.handleEtapaChange('pana_cand_ora')}

                            listUsers={this.state.useri}
                            isUtlizatorOpen={this.state.isOpenUtilizatorEtapa}
                            closeUtilizator={this.closeUtilizatorEtapa}
                            userClick={this.openUserMenuEtapa}
                            dialogClose={() => { this.setState({ isOpenEtapaInsert: false, objEtapaInfo: { denumire: '', note: '', durata_pana_la: null, durata_de_la: new Date() } }) }}
                            dictionary={this.dictionary}
                            numeEtapa={this.state.objEtapaInfo.denumire}
                            descriereEtapa={this.state.objEtapaInfo.note}
                            numeEtapaChange={this.handleEtapaChange('denumire')}
                            descriereEtapaChange={this.handleEtapaChange('note')}
                            insertEtapa={this.addNewEtapa}
                            scop={'Insert'}
                            etapaSelectata={this.state.objEtapaInfo}
                            proiectInfo={this.state.objInfoProiect}
                            etape={this.state.etape}
                            getData={this.getData}
                            changeDataStart={this.changeDataStartEtapa}
                            changeDataFinish={this.changeDataFinishEtapa}

                        />

                        <AlertDialog
                            open={this.state.isOpenAlertDelete}
                            dialogClose={() => { this.setState({ isOpenAlertDelete: false }) }}
                            title={this.state.strEtapaAlert}
                            limba={this.dictionary}
                            yesFunction={this.stergeEtapa}
                        />
                        {

                        }
                        {/* {this.state.etape.map((e,idx)=>{
                return (
                 

                 
                    <EtapeListBeta
                            key={idx}
                            titlu={e.denumire}
                            dict={this.dictionary}
                            listTaskuri={this.state.listTaskuri}
                            listSubTaskuri={this.state.listSubTaskuri}
                            getTaskData={this.getTaskData}
                            dragEndTask={this.dragEndTask}
                            editEtapa={this.editEtapa}
                            deleteEtapa={this.deleteEtapa}
                            dragStart ={this.dragStart}
                            dragOverEt={this.dragOverEt}
                            dropEt={this.dropEt}
                            etapa={e}
                            addNewEtapa={this.addNewEtapa}
                            addNewTask={this.addNewTask}
                           
                            />
                    
                )
            })}    */}

                        {/* <EtapeListBeta
                            titlu={null}
                            addNewEtapa={()=>{this.setState({isOpenEtapaInsert:true})}}
                            dict={this.dictionary} />      */}
                    </div>
                    {/* {this.state.etape.length === 0 && 
            <h3>{this.state.nimicInEtape}</h3>
        }
        {this.state.etape.length > 0 && 
        <EtapeList 
           elemente={this.state.etape}
           dict={this.dictionary}
           status={this.state.etapeStatus}
           changeTitle={this.changeTitle}
           changeNote={this.changeNote}
           openMenuAvatar={this.state.isOpenMenuAvatar}
           openMenu={this.state.menuOpen}
           changeTimer={this.changeTimer}
           elSelectat={this.state.elSelectat}
                closeMenu={this.closeMenuStatus}
                closeMenuAvatar={this.closeMenuAvatar}
                users={this.state.useri}
                avatarClick={this.avatarClick}
           elementSelectat={this.onEtapaClick}
           onlyColumns = {{title:'denumire', idUser:'id_user_responsabil', dataStart:'durata_de_la', dataFinish:'durata_pana_la', statusul:'statusul'}}
           />    
    } */}





                    {/* <EtapeProiectAdd
                open={this.state.openInsert}
                handleClose={()=>{this.setState({openInsert:false})}}
                
                handleAdd={this.insertEtapa}
                title={this.dictionary.proiecte.etapeProiect.titluInsertDialog}
                dict={this.dictionary}
                responasbili={this.state.useri}
                responsabil={this.state.responsabil}
                responsabilChange={(ev)=>{this.setState({responsabil:ev.target.value})}}

                />  */}


                </div>

                {(this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                    <Grid style={{ width: '90%', margin: 'auto', }} container>
                        <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>

                            <h1 className='pm-title-big' style={{ fontSize: 36, fontWeight: 700 }} >{this.state.objInfoProiect[0].titlu}</h1>
                        </Grid>
                        <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <div style={{
                                display: 'inline-flex',
                                lineHeight: 8
                            }} >



                                <Hidden mdDown>

                                    <span>{this.dictionary.proiecte.viewMode}</span>
                                </Hidden>

                                <span style={{lineHeight:4, paddingTop:36}}>
                                    {!this.state.thinkView &&
                                        <IdeeaView onClick={() => { this.changeViewTabel('think') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }

                                    {this.state.thinkView &&
                                        <IdeeaViewBlue onClick={() => { this.changeViewTabel('think') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }

                                    {!this.state.ganttView &&
                                        <GanttView onClick={() => { this.changeViewTabel('gantt') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }

                                    {this.state.ganttView &&
                                        <GanttViewBlue onClick={() => { this.changeViewTabel('gantt') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }

                                    {!this.state.tableView &&
                                        <TableView onClick={() => { this.changeViewTabel('tabel') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }

                                    {this.state.tableView &&
                                        <TableViewBlue onClick={() => { this.changeViewTabel('tabel') }} style={{ width: 30, height: 30, marginRight: 10, lineHeight: 4, cursor: 'pointer' }} />

                                    }
                                </span>
                                {/* <i style={{ fontSize: 30, color: this.state.thinkView ? 'rgb(113, 227, 255)' : 'black', lineHeight: 4, cursor: 'pointer' }} onClick={() => { this.changeViewTabel('think') }} className='material-icons'>emoji_objects</i>




                                <i style={{ fontSize: 30, color: this.state.ganttView ? 'rgb(113, 227, 255)' : 'black', lineHeight: 4, cursor: 'pointer' }} onClick={() => { this.changeViewTabel('gantt') }} className='material-icons'>clear_all</i>





                                <i style={{ fontSize: 30, color: this.state.tableView ? 'rgb(113, 227, 255)' : 'black', lineHeight: 4, cursor: 'pointer' }} onClick={() => { this.changeViewTabel('tabel') }} className='material-icons'>table_chart</i>
 */}


                                <i onClick={this.goToInfoProiect} style={{ fontSize: 30, cursor: 'pointer', lineHeight: 4, cursor: 'pointer', marginLeft: 10 }} className='material-icons'>settings</i>
                            </div>

                        </Grid>

                    </Grid>

                }

                {!this.state.objUser.drepturi_access.acces_extins_proiecte &&
                    <Grid style={{ width: '90%', margin: 'auto', }} container>
                        <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>

                            <h1 className='pm-title-big'>{this.state.objInfoProiect[0].titlu}</h1>
                        </Grid>


                    </Grid>
                }

                {(this.ls.GetUserData().InfoUser.IsAdmin === 1 ? false : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? false : true)) &&
                    <div style={{
                        width: '90%', margin: 'auto', backgroundColor: 'white', height: '90%',
                        overflow: 'scroll'
                    }}>
                        <TasksAngajatView
                            list={this.state.angajatView}
                            showTasks={this.showTasksAngajat}
                            finalizeazaTask={this.finalizeazaTaskAngajat}
                            editTask={this.getTaskData}
                            listEtape={this.state.etape}
                            objEtapaSelectata={this.state.objEtapaSelectata}

                        />

                    </div>
                }


                {this.state.objInfoProiect.length > 0 && this.state.thinkView && (this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                    <div style={{
                        width: '90%', margin: 'auto', backgroundColor: 'white', height: '90%',
                        overflow: 'scroll'
                    }}>
                        <OtherViewProiectIntegral

                            objProiectInfo={this.state.objInfoProiect}
                            listEtape={this.state.etape}
                            listTaskuri={this.state.listTaskuri}
                            listSubTaskuri={this.state.listSubTaskuri}
                            listUsers={this.state.useri}
                            changeTask={this.changeTask}
                            editTask={this.getTaskData}
                            updateTaskTitle={this.updateTaskTitle}
                            dataStartChange={(ev) => { this.dataStartChange(ev) }}
                            dataFinishChange={(ev) => { this.dataFinishChange(ev) }}
                            dtDataStart={this.state.dtDataStart}
                            dtDataFinish={this.state.dtDataFinish}
                            getTaskDates={this.getTaskDates}
                            isUtlizatorOpen={this.state.isOpenUtilizator}
                            userClick={this.userClickedTask}
                            closeUtilizator={this.closeUtilizator}
                            insertTask={this.addNewTask}
                            getData={this.getData}
                        />
                    </div>

                }

                {
                    this.state.objInfoProiect.length > 0 && this.state.etapaView && !this.state.thinkView && (this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                    <div style={{ width: '90%', margin: 'auto' }}>
                        <GanttProiectIntegral
                            objProiectInfo={this.state.objInfoProiect}
                            dictionary={this.dictionary}
                            listEtape={this.state.etape}
                            screenLimit={this.state.windowWidth > 800 ? 30 : (this.state.windowWidth < 600 ? 6 : 12)}
                            listTaskuri={this.state.listTaskuri}
                            changeView={this.changeViewEtape}
                            goToTask={this.goToTaskView}
                            insertEtapa={() => { this.setState({ isOpenEtapaInsert: true }) }}
                            listSubTaskuri={this.state.listSubTaskuri}
                            useri={this.state.useri}
                            showTag={this.showTag}
                            hideTag={this.hideTag}
                            showUserTag={this.showUserTag}
                            hideUserTag={this.hideUserTag}
                            objEtapaSelectata={this.state.objEtapaSelectata}
                            dragOver={this.dragOverEt}
                            dragDrop={this.dropEt}
                        />




                    </div>
                }

                {
                    this.state.etapaSelectataView && !this.state.thinkView && (this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                    <div style={{ width: '90%', margin: 'auto', position: 'relative' }}>

                        <GanttEtapeMonthView
                            objProiectInfo={this.state.objInfoProiect}
                            objEtapaSelectata={this.state.objEtapaSelectata}
                            objTaskSelectat={this.state.objTaskSelectat}
                            tableView={this.state.tableView}
                            ganttView={this.state.ganttView}
                            viewOption={this.state.viewOption}
                            changeViewOption={this.changeViewTabel}
                            // screenLimit={this.state.windowWidth > 800 ? 30 : (this.state.windowWidth < 600 ? 6 : 12)}
                            screenLimit={this.state.tableView ? 6 : 9}
                            dictionary={this.dictionary}
                            listTaskuri={this.state.listTaskuri}
                            listSubTaskuri={this.state.listSubTaskuri}
                            editTask={this.getTaskData}
                            goToTask={this.changeTaskView}
                            editEtapa={this.editEtapa}
                            insertTask={this.addNewTask}
                            displayInapoi={1}
                            changePanaCandData={this.dataFinishChange}
                            changeCandData={this.dataStartChange}
                            changeView={this.changeViewEtape}
                            showTag={this.showTagTask}
                            hideTag={this.hideTagTask}
                            showChangeArrow={this.showChangeArrow}
                            hideChangeArrow={this.hideChangeArrow}
                            updateTasks={this.updateTasks}
                            showUserTag={this.showUserTagTask}
                            hideUserTag={this.hideUserTagTask}
                            finalizeazaTask={this.taskFinalizat}
                            changeTask={this.changeTask}
                            updateTaskTitle={this.updateTaskTitle}
                            getTaskDates={this.getTaskDates}
                            dataStartChange={(ev) => { this.dataStartChange(ev) }}
                            dataFinishChange={(ev) => { this.dataFinishChange(ev) }}
                            dtDataStart={this.state.dtDataStart}
                            dtDataFinish={this.state.dtDataFinish}
                            isUtlizatorOpen={this.state.isOpenUtilizator}
                            userClick={this.userClickedTask}
                            closeUtilizator={this.closeUtilizator}
                            listUsers={this.state.useri}
                            indexEtapa={this.state.indexEtapa}
                            dragStart={this.dragStart}
                            // dragOver={this.dragOverEt}
                            dragEnd={this.dragEndTask}

                        />




                    </div>
                }

                {
                    this.state.taskSelectatView && !this.state.thinkView && (this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                    <div id='subtaskuri-container' style={{ width: '90%', margin: 'auto' }}>
                        <GanttTaskuriFullView
                            objEtapaSelectata={this.state.objEtapaSelectata}
                            objTaskSelectat={this.state.objTaskSelectat}
                            tableView={this.state.tableView}
                            ganttView={this.state.ganttView}
                            viewOption={this.state.viewOption}
                            changeViewOption={this.changeViewTabel}
                            // screenLimit={this.state.windowWidth > 800 ? 30 : (this.state.windowWidth < 600 ? 6 : 12)}
                            siteMapArray={this.state.siteMapArray}
                            screenLimit={this.state.tableView ? 6 : 9}
                            dictionary={this.dictionary}
                            changeView={this.changeViewEtape}
                            listSubTaskuri={this.state.listSubTaskuri}
                            editTask={this.getTaskData}
                            goToTask={this.changeTaskView}
                            changePanaCandData={this.dataFinishChange}
                            changeCandData={this.dataStartChange}
                            displayInapoi={1}
                            insertSubtask={this.insertSubtask}
                            showTag={this.showSubTaskTagTask}
                            hideTag={this.hideSubTaskTagTask}
                            showChangeArrow={this.showSubtaskChangeArrow}
                            hideChangeArrow={this.hideSubtaskChangeArrow}
                            updateTasks={this.updateSubTasks}
                            showUserTag={this.showUserTagSubtask}
                            hideUserTag={this.hideUserTagSubtask}
                            finalizeazaTask={this.subTaskFinalizat}
                            changeTask={this.changeSubTask}
                            updateTaskTitle={this.updateTaskTitle}
                            getTaskDates={this.getSubtaskDates}
                            dataStartChange={(ev) => { this.dataStartChange(ev) }}
                            dataFinishChange={(ev) => { this.dataFinishChange(ev) }}
                            dtDataStart={this.state.dtDataStart}
                            dtDataFinish={this.state.dtDataFinish}
                            isUtlizatorOpen={this.state.isOpenUtilizator}
                            userClick={this.userClickedSubTask}
                            closeUtilizator={this.closeUtilizator}
                            listUsers={this.state.useri}
                        />
                    </div>
                }
                {/* <div style={{width:'100%', overflow:'hidden'}}>
          <div id='pm-gantt-etape-container'  style={{ marginTop:20, overflowX:'scroll', overflowY:'hidden', textAlign:'left', height:'100%', display:'flex', position:'relative'}}>
          {this.state.listTaskuri.length > 0 &&
        
        
          <GanttEtapeWeekView
            objInfoProiect={this.state.objInfoProiect}
            listTaskuri={this.state.listTaskuri}
            listSubtaskuri={this.state.listSubTaskuri}
            etape={this.state.etape}
            dictionary={this.dictionary}
            OpenTask={this.getGanttTaskData}
            getData={this.getData}
            ref={this.ganttChange}
                    />

     
        }
          </div>
          </div> */}
            </div >
        );
    }
}